// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Dash Flows Enhanced Theme System
 *
 * A comprehensive theming stylesheet with:
 * - React Flow colorMode integration (.dark/.light classes)
 * - Mantine color scheme support (data-mantine-color-scheme)
 * - CSS custom properties for programmatic theming
 * - Glass morphism effects with accessibility fallbacks
 * - Theme presets (glass, solid, minimal)
 * - Color schemes (default, ocean, forest, sunset, midnight, rose)
 *
 * Compatible with dash-mantine-components and React Flow 12+
 */

/* =============================================================================
   SECTION 1: CSS CUSTOM PROPERTIES (Theme Variables)
   ============================================================================= */

:root {
    /* ------------------------------------------------------------------
       Glass Effect Properties
       ------------------------------------------------------------------ */
    --df-glass-blur: 12px;
    --df-glass-blur-light: 8px;
    --df-glass-blur-heavy: 20px;
    --df-glass-saturate: 180%;

    /* ------------------------------------------------------------------
       Theme Colors - Light Mode (Default)
       ------------------------------------------------------------------ */

    /* Base glass appearance */
    --df-glass-bg: rgba(255, 255, 255, 0.72);
    --df-glass-bg-hover: rgba(255, 255, 255, 0.85);
    --df-glass-border: rgba(255, 255, 255, 0.5);
    --df-glass-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
    --df-glass-shadow-hover: 0 8px 32px rgba(31, 38, 135, 0.25);
    --df-glass-inset: inset 0 1px 0 0 rgba(255, 255, 255, 0.6);
    --df-glass-inset-bottom: inset 0 -1px 0 0 rgba(0, 0, 0, 0.02);

    /* Node base colors */
    --df-node-bg: var(--df-glass-bg);
    --df-node-bg-hover: var(--df-glass-bg-hover);
    --df-node-border: var(--df-glass-border);
    --df-node-text: #1a1b1e;
    --df-node-text-secondary: #495057;
    --df-node-shadow: var(--df-glass-shadow);

    /* Input node - Green tint */
    --df-input-node-bg: rgba(209, 250, 229, 0.65);
    --df-input-node-bg-hover: rgba(209, 250, 229, 0.8);
    --df-input-node-border: rgba(16, 185, 129, 0.3);
    --df-input-node-accent: #10b981;

    /* Output node - Purple tint */
    --df-output-node-bg: rgba(237, 233, 254, 0.65);
    --df-output-node-bg-hover: rgba(237, 233, 254, 0.8);
    --df-output-node-border: rgba(139, 92, 246, 0.3);
    --df-output-node-accent: #8b5cf6;

    /* Default node - Neutral */
    --df-default-node-bg: var(--df-glass-bg);
    --df-default-node-border: var(--df-glass-border);
    --df-default-node-accent: #3b82f6;

    /* Group node */
    --df-group-node-bg: rgba(243, 244, 246, 0.5);
    --df-group-node-border: rgba(156, 163, 175, 0.4);

    /* Toolbar & panels */
    --df-toolbar-bg: rgba(255, 255, 255, 0.95);
    --df-toolbar-border: rgba(0, 0, 0, 0.1);
    --df-toolbar-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    /* Edge colors */
    --df-edge-stroke: #64748b;
    --df-edge-stroke-width: 2;
    --df-edge-stroke-selected: #3b82f6;
    --df-edge-stroke-animated: #8b5cf6;

    /* Edge label */
    --df-edge-label-bg: rgba(255, 255, 255, 0.85);
    --df-edge-label-border: rgba(255, 255, 255, 0.6);
    --df-edge-label-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    /* Handle colors */
    --df-handle-bg: #fff;
    --df-handle-border: #64748b;
    --df-handle-bg-connected: #3b82f6;
    --df-handle-bg-valid: #10b981;
    --df-handle-size: 14px;
    --df-handle-size-hover: 18px;

    /* Background */
    --df-background-color: #fafafa;
    --df-background-pattern: #e5e7eb;

    /* Controls & MiniMap */
    --df-controls-bg: var(--df-glass-bg);
    --df-controls-border: var(--df-glass-border);
    --df-minimap-bg: rgba(255, 255, 255, 0.85);
    --df-minimap-mask: rgba(59, 130, 246, 0.15);
    --df-minimap-node-fill: #64748b;
    --df-minimap-node-stroke: #475569;

    /* Selection */
    --df-selection-bg: rgba(59, 130, 246, 0.08);
    --df-selection-border: rgba(59, 130, 246, 0.4);
    --df-selection-ring: 0 0 0 2px var(--df-selection-border);

    /* Connection line */
    --df-connection-line-stroke: var(--df-edge-stroke-selected);
    --df-connection-line-width: 2;

    /* ------------------------------------------------------------------
       Spacing & Sizing
       ------------------------------------------------------------------ */
    --df-spacing-xs: 4px;
    --df-spacing-sm: 8px;
    --df-spacing-md: 12px;
    --df-spacing-lg: 16px;
    --df-spacing-xl: 24px;

    /* Border radius */
    --df-radius-xs: 4px;
    --df-radius-sm: 6px;
    --df-radius-md: 10px;
    --df-radius-lg: 14px;
    --df-radius-xl: 20px;

    /* Transitions */
    --df-transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
    --df-transition-normal: 250ms cubic-bezier(0.4, 0, 0.2, 1);
    --df-transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);

    /* Node sizing */
    --df-node-min-width: 150px;
    --df-node-default-width: clamp(160px, 18vw, 300px);
    --df-group-node-min-width: clamp(220px, 22vw, 400px);
    --df-group-node-min-height: clamp(180px, 25vh, 400px);

    /* ------------------------------------------------------------------
       Map to React Flow CSS Variables
       ------------------------------------------------------------------ */
    --xy-edge-stroke-default: var(--df-edge-stroke);
    --xy-edge-stroke-width-default: var(--df-edge-stroke-width);
    --xy-edge-stroke-selected-default: var(--df-edge-stroke-selected);
    --xy-connectionline-stroke-default: var(--df-connection-line-stroke);
    --xy-connectionline-stroke-width-default: var(--df-connection-line-width);
    --xy-node-background-color-default: var(--df-node-bg);
    --xy-node-border-default: 1px solid var(--df-node-border);
    --xy-node-color-default: var(--df-node-text);
    --xy-handle-background-color-default: var(--df-handle-bg);
    --xy-handle-border-color-default: var(--df-handle-border);
    --xy-background-pattern-dots-color-default: var(--df-background-pattern);
    --xy-background-pattern-line-color-default: var(--df-background-pattern);
    --xy-background-pattern-cross-color-default: var(--df-background-pattern);
    --xy-minimap-background-color-default: var(--df-minimap-bg);
    --xy-selection-background-color-default: var(--df-selection-bg);
    --xy-selection-border-default: 1px dotted var(--df-selection-border);
    --xy-controls-button-background-color-default: var(--df-controls-bg);
    --xy-controls-button-border-color-default: var(--df-controls-border);
}

/* =============================================================================
   SECTION 2: DARK MODE VARIABLES

   Supports multiple dark mode detection methods:
   - React Flow colorMode="dark" adds .dark class
   - Mantine uses data-mantine-color-scheme="dark"
   - Custom data-theme="dark" attribute
   ============================================================================= */

/* React Flow dark mode */
.react-flow.dark,
/* Mantine dark mode */
:root[data-mantine-color-scheme="dark"],
[data-mantine-color-scheme="dark"],
/* Custom dark mode class */
.dark-mode,
[data-theme="dark"] {
    /* Glass effect - Dark mode */
    --df-glass-bg: rgba(26, 27, 30, 0.72);
    --df-glass-bg-hover: rgba(37, 38, 43, 0.85);
    --df-glass-border: rgba(255, 255, 255, 0.08);
    --df-glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
    --df-glass-shadow-hover: 0 8px 32px rgba(0, 0, 0, 0.5);
    --df-glass-inset: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);
    --df-glass-inset-bottom: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);

    /* Node colors - Dark mode */
    --df-node-bg: var(--df-glass-bg);
    --df-node-bg-hover: var(--df-glass-bg-hover);
    --df-node-border: var(--df-glass-border);
    --df-node-text: #f1f3f5;
    --df-node-text-secondary: #909296;
    --df-node-shadow: var(--df-glass-shadow);

    /* Input node - Green tint dark */
    --df-input-node-bg: rgba(6, 78, 59, 0.45);
    --df-input-node-bg-hover: rgba(6, 78, 59, 0.6);
    --df-input-node-border: rgba(16, 185, 129, 0.25);
    --df-input-node-accent: #34d399;

    /* Output node - Purple tint dark */
    --df-output-node-bg: rgba(76, 29, 149, 0.35);
    --df-output-node-bg-hover: rgba(76, 29, 149, 0.5);
    --df-output-node-border: rgba(139, 92, 246, 0.25);
    --df-output-node-accent: #a78bfa;

    /* Default node */
    --df-default-node-bg: var(--df-glass-bg);
    --df-default-node-border: var(--df-glass-border);
    --df-default-node-accent: #60a5fa;

    /* Group node dark */
    --df-group-node-bg: rgba(55, 65, 81, 0.4);
    --df-group-node-border: rgba(107, 114, 128, 0.4);

    /* Toolbar dark */
    --df-toolbar-bg: rgba(37, 38, 43, 0.95);
    --df-toolbar-border: rgba(255, 255, 255, 0.1);
    --df-toolbar-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    /* Edge colors dark */
    --df-edge-stroke: #94a3b8;
    --df-edge-stroke-selected: #60a5fa;
    --df-edge-stroke-animated: #a78bfa;

    /* Edge label dark */
    --df-edge-label-bg: rgba(37, 38, 43, 0.9);
    --df-edge-label-border: rgba(255, 255, 255, 0.1);
    --df-edge-label-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    /* Handle colors dark */
    --df-handle-bg: #25262b;
    --df-handle-border: #94a3b8;
    --df-handle-bg-connected: #60a5fa;
    --df-handle-bg-valid: #34d399;

    /* Background dark */
    --df-background-color: #1a1b1e;
    --df-background-pattern: #2c2e33;

    /* Controls & MiniMap dark */
    --df-controls-bg: var(--df-glass-bg);
    --df-controls-border: var(--df-glass-border);
    --df-minimap-bg: rgba(26, 27, 30, 0.85);
    --df-minimap-mask: rgba(96, 165, 250, 0.2);
    --df-minimap-node-fill: #94a3b8;
    --df-minimap-node-stroke: #64748b;

    /* Selection dark */
    --df-selection-bg: rgba(96, 165, 250, 0.12);
    --df-selection-border: rgba(96, 165, 250, 0.5);

    /* Connection line dark */
    --df-connection-line-stroke: var(--df-edge-stroke-selected);
}

/* =============================================================================
   SECTION 3: THEME PRESETS

   Apply these classes to the DashFlows container:
   - .df-theme-glass (default)
   - .df-theme-solid
   - .df-theme-minimal
   ============================================================================= */

/* Glass Theme (Default) - Already defined above */
.df-theme-glass {
    /* Uses default glass variables */
}

/* Solid Theme - No transparency, opaque cards with shadows */
.df-theme-solid,
.df-theme-solid .react-flow {
    --df-glass-blur: 0px;
    --df-glass-saturate: 100%;
    --df-glass-bg: #ffffff;
    --df-glass-bg-hover: #f8fafc;
    --df-glass-border: #e2e8f0;
    --df-glass-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
    --df-glass-shadow-hover: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    --df-glass-inset: none;
    --df-glass-inset-bottom: none;
    --df-node-bg: #ffffff;
    --df-node-bg-hover: #f8fafc;
    --df-node-border: #e2e8f0;
    --df-input-node-bg: #dcfce7;
    --df-input-node-bg-hover: #bbf7d0;
    --df-input-node-border: #86efac;
    --df-output-node-bg: #f3e8ff;
    --df-output-node-bg-hover: #e9d5ff;
    --df-output-node-border: #c4b5fd;
    --df-default-node-bg: #ffffff;
    --df-default-node-border: #e2e8f0;
    --df-controls-bg: #ffffff;
    --df-minimap-bg: #ffffff;
    --df-toolbar-bg: #ffffff;
    --df-edge-label-bg: #ffffff;
    --df-background-color: #f8fafc;
}

[data-mantine-color-scheme="dark"] .df-theme-solid,
[data-mantine-color-scheme="dark"] .df-theme-solid .react-flow,
.df-theme-solid .react-flow.dark {
    --df-glass-bg: #1e1e1e;
    --df-glass-bg-hover: #2d2d2d;
    --df-glass-border: #404040;
    --df-glass-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);
    --df-glass-shadow-hover: 0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3);
    --df-node-bg: #1e1e1e;
    --df-node-bg-hover: #2d2d2d;
    --df-node-border: #404040;
    --df-input-node-bg: #14532d;
    --df-input-node-bg-hover: #166534;
    --df-input-node-border: #22c55e;
    --df-output-node-bg: #581c87;
    --df-output-node-bg-hover: #6b21a8;
    --df-output-node-border: #a855f7;
    --df-default-node-bg: #1e1e1e;
    --df-default-node-border: #404040;
    --df-controls-bg: #1e1e1e;
    --df-minimap-bg: #1e1e1e;
    --df-toolbar-bg: #1e1e1e;
    --df-edge-label-bg: #1e1e1e;
    --df-background-color: #121212;
    --df-background-pattern: #2a2a2a;
}

/* Minimal Theme - Clean lines, subtle styling, border-focused */
.df-theme-minimal,
.df-theme-minimal .react-flow {
    --df-glass-blur: 0px;
    --df-glass-saturate: 100%;
    --df-glass-bg: transparent;
    --df-glass-bg-hover: rgba(0, 0, 0, 0.03);
    --df-glass-border: #d1d5db;
    --df-glass-shadow: none;
    --df-glass-shadow-hover: none;
    --df-glass-inset: none;
    --df-glass-inset-bottom: none;
    --df-radius-lg: 6px;
    --df-radius-xl: 8px;
    --df-node-bg: transparent;
    --df-node-bg-hover: rgba(0, 0, 0, 0.03);
    --df-node-border: #d1d5db;
    --df-node-shadow: none;
    --df-input-node-bg: transparent;
    --df-input-node-bg-hover: rgba(16, 185, 129, 0.05);
    --df-input-node-border: #10b981;
    --df-output-node-bg: transparent;
    --df-output-node-bg-hover: rgba(139, 92, 246, 0.05);
    --df-output-node-border: #8b5cf6;
    --df-default-node-bg: transparent;
    --df-default-node-border: #d1d5db;
    --df-toolbar-shadow: none;
    --df-edge-label-shadow: none;
    --df-background-color: #ffffff;
    --df-background-pattern: #f3f4f6;
}

[data-mantine-color-scheme="dark"] .df-theme-minimal,
[data-mantine-color-scheme="dark"] .df-theme-minimal .react-flow,
.df-theme-minimal .react-flow.dark {
    --df-glass-bg-hover: rgba(255, 255, 255, 0.03);
    --df-glass-border: #4b5563;
    --df-node-bg: transparent;
    --df-node-bg-hover: rgba(255, 255, 255, 0.03);
    --df-node-border: #4b5563;
    --df-input-node-bg: transparent;
    --df-input-node-bg-hover: rgba(52, 211, 153, 0.08);
    --df-input-node-border: #34d399;
    --df-output-node-bg: transparent;
    --df-output-node-bg-hover: rgba(167, 139, 250, 0.08);
    --df-output-node-border: #a78bfa;
    --df-default-node-bg: transparent;
    --df-default-node-border: #4b5563;
    --df-background-color: #111827;
    --df-background-pattern: #1f2937;
}

/* =============================================================================
   SECTION 3B: COLOR SCHEMES

   Apply these classes to the DashFlows container:
   - .df-scheme-default (neutral blue/purple)
   - .df-scheme-ocean (blues and teals)
   - .df-scheme-forest (greens and browns)
   - .df-scheme-sunset (oranges and reds)
   - .df-scheme-midnight (deep blues and purples)
   - .df-scheme-rose (pinks and reds)
   ============================================================================= */

/* Default scheme - already defined in :root */
.df-scheme-default {
    /* Uses default colors */
}

/* Ocean - Blues and Teals */
.df-scheme-ocean,
.df-scheme-ocean .react-flow {
    --df-input-node-bg: rgba(207, 250, 254, 0.65);
    --df-input-node-bg-hover: rgba(207, 250, 254, 0.8);
    --df-input-node-border: rgba(6, 182, 212, 0.3);
    --df-input-node-accent: #06b6d4;
    --df-output-node-bg: rgba(219, 234, 254, 0.65);
    --df-output-node-bg-hover: rgba(219, 234, 254, 0.8);
    --df-output-node-border: rgba(59, 130, 246, 0.3);
    --df-output-node-accent: #3b82f6;
    --df-default-node-accent: #0891b2;
    --df-edge-stroke: #0891b2;
    --df-edge-stroke-selected: #06b6d4;
    --df-edge-stroke-animated: #0ea5e9;
    --df-handle-bg-connected: #06b6d4;
    --df-handle-bg-valid: #14b8a6;
    --df-selection-bg: rgba(6, 182, 212, 0.08);
    --df-selection-border: rgba(6, 182, 212, 0.4);
    --df-minimap-mask: rgba(6, 182, 212, 0.15);
    --df-background-color: #f0f9ff;
    --df-background-pattern: #bae6fd;
}

[data-mantine-color-scheme="dark"] .df-scheme-ocean,
[data-mantine-color-scheme="dark"] .df-scheme-ocean .react-flow,
.df-scheme-ocean .react-flow.dark {
    --df-input-node-bg: rgba(8, 145, 178, 0.35);
    --df-input-node-bg-hover: rgba(8, 145, 178, 0.5);
    --df-input-node-border: rgba(34, 211, 238, 0.25);
    --df-input-node-accent: #22d3ee;
    --df-output-node-bg: rgba(29, 78, 216, 0.35);
    --df-output-node-bg-hover: rgba(29, 78, 216, 0.5);
    --df-output-node-border: rgba(96, 165, 250, 0.25);
    --df-output-node-accent: #60a5fa;
    --df-default-node-accent: #22d3ee;
    --df-edge-stroke: #67e8f9;
    --df-edge-stroke-selected: #22d3ee;
    --df-edge-stroke-animated: #38bdf8;
    --df-handle-bg-connected: #22d3ee;
    --df-handle-bg-valid: #2dd4bf;
    --df-background-color: #0c1929;
    --df-background-pattern: #164e63;
}

/* Forest - Greens and Browns */
.df-scheme-forest,
.df-scheme-forest .react-flow {
    --df-input-node-bg: rgba(220, 252, 231, 0.65);
    --df-input-node-bg-hover: rgba(220, 252, 231, 0.8);
    --df-input-node-border: rgba(34, 197, 94, 0.3);
    --df-input-node-accent: #22c55e;
    --df-output-node-bg: rgba(254, 243, 199, 0.65);
    --df-output-node-bg-hover: rgba(254, 243, 199, 0.8);
    --df-output-node-border: rgba(161, 98, 7, 0.3);
    --df-output-node-accent: #a16207;
    --df-default-node-accent: #16a34a;
    --df-edge-stroke: #65a30d;
    --df-edge-stroke-selected: #22c55e;
    --df-edge-stroke-animated: #84cc16;
    --df-handle-bg-connected: #22c55e;
    --df-handle-bg-valid: #4ade80;
    --df-selection-bg: rgba(34, 197, 94, 0.08);
    --df-selection-border: rgba(34, 197, 94, 0.4);
    --df-minimap-mask: rgba(34, 197, 94, 0.15);
    --df-background-color: #f0fdf4;
    --df-background-pattern: #bbf7d0;
}

[data-mantine-color-scheme="dark"] .df-scheme-forest,
[data-mantine-color-scheme="dark"] .df-scheme-forest .react-flow,
.df-scheme-forest .react-flow.dark {
    --df-input-node-bg: rgba(21, 128, 61, 0.35);
    --df-input-node-bg-hover: rgba(21, 128, 61, 0.5);
    --df-input-node-border: rgba(74, 222, 128, 0.25);
    --df-input-node-accent: #4ade80;
    --df-output-node-bg: rgba(120, 53, 15, 0.35);
    --df-output-node-bg-hover: rgba(120, 53, 15, 0.5);
    --df-output-node-border: rgba(251, 191, 36, 0.25);
    --df-output-node-accent: #fbbf24;
    --df-default-node-accent: #4ade80;
    --df-edge-stroke: #a3e635;
    --df-edge-stroke-selected: #4ade80;
    --df-edge-stroke-animated: #bef264;
    --df-handle-bg-connected: #4ade80;
    --df-handle-bg-valid: #86efac;
    --df-background-color: #052e16;
    --df-background-pattern: #14532d;
}

/* Sunset - Oranges and Reds */
.df-scheme-sunset,
.df-scheme-sunset .react-flow {
    --df-input-node-bg: rgba(255, 237, 213, 0.65);
    --df-input-node-bg-hover: rgba(255, 237, 213, 0.8);
    --df-input-node-border: rgba(249, 115, 22, 0.3);
    --df-input-node-accent: #f97316;
    --df-output-node-bg: rgba(254, 226, 226, 0.65);
    --df-output-node-bg-hover: rgba(254, 226, 226, 0.8);
    --df-output-node-border: rgba(239, 68, 68, 0.3);
    --df-output-node-accent: #ef4444;
    --df-default-node-accent: #ea580c;
    --df-edge-stroke: #ea580c;
    --df-edge-stroke-selected: #f97316;
    --df-edge-stroke-animated: #fb923c;
    --df-handle-bg-connected: #f97316;
    --df-handle-bg-valid: #fb923c;
    --df-selection-bg: rgba(249, 115, 22, 0.08);
    --df-selection-border: rgba(249, 115, 22, 0.4);
    --df-minimap-mask: rgba(249, 115, 22, 0.15);
    --df-background-color: #fffbeb;
    --df-background-pattern: #fed7aa;
}

[data-mantine-color-scheme="dark"] .df-scheme-sunset,
[data-mantine-color-scheme="dark"] .df-scheme-sunset .react-flow,
.df-scheme-sunset .react-flow.dark {
    --df-input-node-bg: rgba(194, 65, 12, 0.35);
    --df-input-node-bg-hover: rgba(194, 65, 12, 0.5);
    --df-input-node-border: rgba(251, 146, 60, 0.25);
    --df-input-node-accent: #fb923c;
    --df-output-node-bg: rgba(185, 28, 28, 0.35);
    --df-output-node-bg-hover: rgba(185, 28, 28, 0.5);
    --df-output-node-border: rgba(248, 113, 113, 0.25);
    --df-output-node-accent: #f87171;
    --df-default-node-accent: #fb923c;
    --df-edge-stroke: #fdba74;
    --df-edge-stroke-selected: #fb923c;
    --df-edge-stroke-animated: #fcd34d;
    --df-handle-bg-connected: #fb923c;
    --df-handle-bg-valid: #fdba74;
    --df-background-color: #27150a;
    --df-background-pattern: #431407;
}

/* Midnight - Deep Blues and Purples */
.df-scheme-midnight,
.df-scheme-midnight .react-flow {
    --df-input-node-bg: rgba(224, 231, 255, 0.65);
    --df-input-node-bg-hover: rgba(224, 231, 255, 0.8);
    --df-input-node-border: rgba(99, 102, 241, 0.3);
    --df-input-node-accent: #6366f1;
    --df-output-node-bg: rgba(243, 232, 255, 0.65);
    --df-output-node-bg-hover: rgba(243, 232, 255, 0.8);
    --df-output-node-border: rgba(168, 85, 247, 0.3);
    --df-output-node-accent: #a855f7;
    --df-default-node-accent: #818cf8;
    --df-edge-stroke: #6366f1;
    --df-edge-stroke-selected: #818cf8;
    --df-edge-stroke-animated: #a78bfa;
    --df-handle-bg-connected: #818cf8;
    --df-handle-bg-valid: #a78bfa;
    --df-selection-bg: rgba(99, 102, 241, 0.08);
    --df-selection-border: rgba(99, 102, 241, 0.4);
    --df-minimap-mask: rgba(99, 102, 241, 0.15);
    --df-background-color: #eef2ff;
    --df-background-pattern: #c7d2fe;
}

[data-mantine-color-scheme="dark"] .df-scheme-midnight,
[data-mantine-color-scheme="dark"] .df-scheme-midnight .react-flow,
.df-scheme-midnight .react-flow.dark {
    --df-input-node-bg: rgba(67, 56, 202, 0.35);
    --df-input-node-bg-hover: rgba(67, 56, 202, 0.5);
    --df-input-node-border: rgba(129, 140, 248, 0.25);
    --df-input-node-accent: #818cf8;
    --df-output-node-bg: rgba(126, 34, 206, 0.35);
    --df-output-node-bg-hover: rgba(126, 34, 206, 0.5);
    --df-output-node-border: rgba(192, 132, 252, 0.25);
    --df-output-node-accent: #c084fc;
    --df-default-node-accent: #a5b4fc;
    --df-edge-stroke: #a5b4fc;
    --df-edge-stroke-selected: #818cf8;
    --df-edge-stroke-animated: #c4b5fd;
    --df-handle-bg-connected: #818cf8;
    --df-handle-bg-valid: #a78bfa;
    --df-background-color: #0f0a29;
    --df-background-pattern: #1e1b4b;
}

/* Rose - Pinks and Reds */
.df-scheme-rose,
.df-scheme-rose .react-flow {
    --df-input-node-bg: rgba(255, 228, 230, 0.65);
    --df-input-node-bg-hover: rgba(255, 228, 230, 0.8);
    --df-input-node-border: rgba(244, 63, 94, 0.3);
    --df-input-node-accent: #f43f5e;
    --df-output-node-bg: rgba(252, 231, 243, 0.65);
    --df-output-node-bg-hover: rgba(252, 231, 243, 0.8);
    --df-output-node-border: rgba(236, 72, 153, 0.3);
    --df-output-node-accent: #ec4899;
    --df-default-node-accent: #fb7185;
    --df-edge-stroke: #e11d48;
    --df-edge-stroke-selected: #f43f5e;
    --df-edge-stroke-animated: #fb7185;
    --df-handle-bg-connected: #f43f5e;
    --df-handle-bg-valid: #fb7185;
    --df-selection-bg: rgba(244, 63, 94, 0.08);
    --df-selection-border: rgba(244, 63, 94, 0.4);
    --df-minimap-mask: rgba(244, 63, 94, 0.15);
    --df-background-color: #fff1f2;
    --df-background-pattern: #fecdd3;
}

[data-mantine-color-scheme="dark"] .df-scheme-rose,
[data-mantine-color-scheme="dark"] .df-scheme-rose .react-flow,
.df-scheme-rose .react-flow.dark {
    --df-input-node-bg: rgba(190, 18, 60, 0.35);
    --df-input-node-bg-hover: rgba(190, 18, 60, 0.5);
    --df-input-node-border: rgba(251, 113, 133, 0.25);
    --df-input-node-accent: #fb7185;
    --df-output-node-bg: rgba(157, 23, 77, 0.35);
    --df-output-node-bg-hover: rgba(157, 23, 77, 0.5);
    --df-output-node-border: rgba(244, 114, 182, 0.25);
    --df-output-node-accent: #f472b6;
    --df-default-node-accent: #fda4af;
    --df-edge-stroke: #fda4af;
    --df-edge-stroke-selected: #fb7185;
    --df-edge-stroke-animated: #f9a8d4;
    --df-handle-bg-connected: #fb7185;
    --df-handle-bg-valid: #fda4af;
    --df-background-color: #1f0a14;
    --df-background-pattern: #4c0519;
}

/* =============================================================================
   SECTION 4: REACT FLOW CONTAINER
   ============================================================================= */

.react-flow {
    background-color: var(--df-background-color);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

.react-flow__background {
    background-color: var(--df-background-color);
}

.react-flow__background pattern circle {
    fill: var(--df-background-pattern);
}

.react-flow__background pattern line {
    stroke: var(--df-background-pattern);
}

/* =============================================================================
   SECTION 5: NODE BASE STYLES
   ============================================================================= */

/* Reset React Flow node defaults */
.react-flow__node {
    overflow: visible !important;
}

.react-flow__node.selected,
.react-flow__node:focus,
.react-flow__node:focus-visible {
    outline: none !important;
}

/* Remove React Flow's default node container styling */
.react-flow__node-input,
.react-flow__node-default,
.react-flow__node-output {
    width: auto !important;
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
}

/* Also target when selected to prevent React Flow's selected styling */
.react-flow__node-input.selected,
.react-flow__node-default.selected,
.react-flow__node-output.selected {
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

/* Glass Node Base */
.df-glass-node {
    position: relative;
    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
    background: var(--df-node-bg);
    border: 1px solid var(--df-node-border);
    border-radius: var(--df-radius-lg);
    box-shadow: var(--df-node-shadow), var(--df-glass-inset), var(--df-glass-inset-bottom);
    color: var(--df-node-text);
    padding: var(--df-spacing-md) var(--df-spacing-lg);
    min-width: var(--df-node-min-width);
    /* Use max-width instead of width for flexibility with layout system */
    max-width: var(--df-node-default-width);
    box-sizing: border-box;
    overflow: visible;
    text-align: center;
    transition:
        background var(--df-transition-normal),
        box-shadow var(--df-transition-normal),
        transform var(--df-transition-normal),
        border-color var(--df-transition-normal);
    will-change: transform, box-shadow;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}

.df-glass-node:hover {
    background: var(--df-node-bg-hover);
    box-shadow: var(--df-glass-shadow-hover), var(--df-glass-inset), var(--df-glass-inset-bottom);
    transform: translateY(-1px) translateZ(0);
}

.df-glass-node.selected {
    border-color: var(--df-edge-stroke-selected);
    box-shadow:
        var(--df-glass-shadow-hover),
        var(--df-glass-inset),
        var(--df-glass-inset-bottom),
        var(--df-selection-ring);
}

/* Node content */
.df-node-content {
    overflow: hidden;
}

.df-node-label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    /* Text shadow for readability over glass */
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.df-node-label.multiline {
    white-space: normal;
    word-wrap: break-word;
}

.df-node-sublabel {
    font-size: 11px;
    color: var(--df-node-text-secondary);
    margin-top: var(--df-spacing-xs);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Node icon container */
.df-node-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    width: 24px;
    height: 24px;
    border-radius: var(--df-radius-sm);
    margin-bottom: var(--df-spacing-sm);
    color: white;
    font-size: 12px;
    flex-shrink: 0;
}

/* Custom icon styling (for DashIconify or other Dash components) */
.df-node-icon.df-icon-custom {
    background: transparent;
    color: var(--df-node-text-primary);
    width: auto;
    height: auto;
    min-width: 20px;
    min-height: 20px;
}

/* Ensure DashIconify icons inherit proper sizing */
.df-node-icon.df-icon-custom svg {
    display: block;
}

/* Node body text (additional description below label/sublabel) */
.df-node-body {
    font-size: 11px;
    color: var(--df-node-text-secondary);
    margin-top: var(--df-spacing-xs);
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
}

.df-node-body.multiline {
    white-space: normal;
    word-wrap: break-word;
    max-width: none;
}

/* =============================================================================
   SECTION 5B: NODE LAYOUT SYSTEM
   ============================================================================= */

/* --- Base Layout Classes --- */

/* Stacked layout (default) - vertical arrangement */
.df-glass-node.df-layout-stacked {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Horizontal layout - two column arrangement */
.df-glass-node.df-layout-horizontal {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    min-width: auto !important;
    width: auto !important;
    text-align: left !important;
}

/* --- Icon Only Configuration --- */

.df-glass-node.df-icon-only {
    min-width: auto !important;
    width: auto !important;
    padding: var(--df-spacing-sm) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.df-glass-node.df-icon-only .df-node-icon {
    margin: 0 !important;
}

.df-glass-node.df-icon-only .df-node-content {
    display: none !important;
}

/* Icon only with accent bars - adjust padding */
.df-glass-node.df-input-node.df-icon-only {
    padding-top: calc(var(--df-spacing-sm) + 4px) !important;
}

.df-glass-node.df-output-node.df-icon-only {
    padding-bottom: calc(var(--df-spacing-sm) + 4px) !important;
}

/* --- Text Only Configuration --- */

.df-glass-node.df-text-only {
    text-align: center;
}

.df-glass-node.df-text-only .df-node-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.df-glass-node.df-text-only .df-node-label,
.df-glass-node.df-text-only .df-node-body {
    text-align: center;
}

/* --- Full Content Configuration --- */

/* Stacked full content - current default behavior */
.df-glass-node.df-layout-stacked.df-full-content {
    /* Uses existing styling */
}

/* Horizontal full content - two columns */
.df-glass-node.df-layout-horizontal.df-full-content {
    gap: var(--df-spacing-md);
    padding: var(--df-spacing-sm) var(--df-spacing-md);
}

/* Icon column in horizontal layout */
.df-node-icon-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.df-glass-node.df-layout-horizontal .df-node-icon-column .df-node-icon {
    margin: 0;
}

/* Text column in horizontal layout */
.df-node-text-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex: 1;
    text-align: left;
}

.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-label {
    text-align: left;
}

.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-sublabel {
    text-align: left;
}

.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-body {
    text-align: left;
    margin-top: var(--df-spacing-xs);
}

/* Horizontal layout with accent bars */
.df-glass-node.df-input-node.df-layout-horizontal {
    padding-top: calc(var(--df-spacing-sm) + 4px);
}

.df-glass-node.df-output-node.df-layout-horizontal {
    padding-bottom: calc(var(--df-spacing-sm) + 4px);
}

/* =============================================================================
   SECTION 6: SPECIFIC NODE TYPES
   ============================================================================= */

/* Input Node */
.df-glass-node.df-input-node {
    background: var(--df-input-node-bg);
    border-color: var(--df-input-node-border);
    padding-top: calc(var(--df-spacing-md) + 4px);
}

.df-glass-node.df-input-node:hover {
    background: var(--df-input-node-bg-hover);
}

.df-glass-node.df-input-node .df-node-accent-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--df-input-node-accent);
    border-radius: var(--df-radius-lg) var(--df-radius-lg) 0 0;
}

.df-glass-node.df-input-node .df-node-icon {
    background: var(--df-input-node-accent);
}

/* Output Node */
.df-glass-node.df-output-node {
    background: var(--df-output-node-bg);
    border-color: var(--df-output-node-border);
    padding-bottom: calc(var(--df-spacing-md) + 4px);
}

.df-glass-node.df-output-node:hover {
    background: var(--df-output-node-bg-hover);
}

.df-glass-node.df-output-node .df-node-accent-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--df-output-node-accent);
    border-radius: 0 0 var(--df-radius-lg) var(--df-radius-lg);
}

.df-glass-node.df-output-node .df-node-icon {
    background: var(--df-output-node-accent);
}

/* Default Node */
.df-glass-node.df-default-node {
    background: var(--df-default-node-bg);
    border-color: var(--df-default-node-border);
}

/* Group Node - Style the React Flow wrapper directly */
.react-flow__node-group {
    background: var(--df-group-node-bg) !important;
    border: 2px dashed var(--df-group-node-border) !important;
    border-radius: var(--df-radius-lg) !important;
    padding: 0 !important;
    z-index: 0 !important;
}

.react-flow__node-group.selected {
    border: 2px solid var(--df-selection-border) !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    z-index: 0 !important;
}

/* Group node label badge */
.df-group-node-label {
    position: absolute;
    top: 8px;
    left: 8px;
    background: var(--df-toolbar-bg);
    padding: 4px 10px;
    border-radius: var(--df-radius-sm);
    font-size: 11px;
    font-weight: 600;
    color: var(--df-node-text-secondary);
    border: 1px solid var(--df-node-border);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    z-index: 1;
    pointer-events: none;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

/* Resize handles - only show on selection */
.react-flow__node-group .react-flow__resize-control {
    opacity: 0;
    transition: opacity 150ms ease;
}

.react-flow__node-group.selected .react-flow__resize-control {
    opacity: 1;
}

/* =============================================================================
   SECTION 7: HANDLES
   ============================================================================= */

.react-flow__handle {
    width: var(--df-handle-size);
    height: var(--df-handle-size);
    background: var(--df-handle-bg);
    border: 2px solid var(--df-handle-border);
    border-radius: 50%;
    z-index: 10;
    transition:
        width var(--df-transition-fast),
        height var(--df-transition-fast),
        border-color var(--df-transition-fast),
        background var(--df-transition-fast),
        box-shadow var(--df-transition-fast),
        margin var(--df-transition-fast);
    box-sizing: content-box;
}

/* Invisible hit area */
.react-flow__handle::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 24px;
    height: 24px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
}

.react-flow__handle:hover {
    width: var(--df-handle-size-hover);
    height: var(--df-handle-size-hover);
    margin: -2px;
    border-color: var(--df-edge-stroke-selected);
    box-shadow: 0 0 12px rgba(59, 130, 246, 0.5);
    cursor: crosshair;
}

/* Position-specific hover adjustments */
.react-flow__handle-top:hover { margin-top: -5px; }
.react-flow__handle-bottom:hover { margin-bottom: -5px; }
.react-flow__handle-left:hover { margin-left: -5px; }
.react-flow__handle-right:hover { margin-right: -5px; }

/* Handle positions */
.react-flow__handle-top { top: -7px; }
.react-flow__handle-bottom { bottom: -7px; }
.react-flow__handle-left { left: -7px; }
.react-flow__handle-right { right: -7px; }

/* Active/connecting state */
.react-flow__handle:active,
.react-flow__handle.connectingfrom,
.react-flow__handle.connectingto {
    width: 20px;
    height: 20px;
    margin: -3px;
    border-color: var(--df-edge-stroke-selected);
    box-shadow: 0 0 16px rgba(59, 130, 246, 0.6);
}

.react-flow__handle.connecting {
    animation: df-handle-pulse 1s ease-in-out infinite;
}

/* Valid connection indicator */
.react-flow__handle.valid {
    background: var(--df-handle-bg-valid);
    border-color: var(--df-handle-bg-valid);
    box-shadow: 0 0 12px rgba(16, 185, 129, 0.5);
}

/* Connected handle */
.react-flow__handle.connected {
    background: var(--df-handle-bg-connected);
    border-color: var(--df-handle-bg-connected);
}

@keyframes df-handle-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4); }
    50% { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0); }
}

/* =============================================================================
   SECTION 8: EDGES
   ============================================================================= */

.react-flow__edge-path {
    stroke: var(--df-edge-stroke);
    stroke-width: var(--df-edge-stroke-width);
    fill: none;
    transition: stroke var(--df-transition-fast), stroke-width var(--df-transition-fast);
}

.react-flow__edge:hover .react-flow__edge-path,
.react-flow__edge.selected .react-flow__edge-path {
    stroke: var(--df-edge-stroke-selected);
    stroke-width: 2.5;
}

/* Animated edge */
.react-flow__edge.animated .react-flow__edge-path {
    stroke: var(--df-edge-stroke-animated);
    stroke-dasharray: 5;
    animation: df-edge-flow 0.5s linear infinite;
}

@keyframes df-edge-flow {
    from { stroke-dashoffset: 10; }
    to { stroke-dashoffset: 0; }
}

/* Edge label */
.df-edge-label {
    display: flex;
    align-items: center;
    gap: var(--df-spacing-xs);
    padding: var(--df-spacing-xs) var(--df-spacing-sm);
    background: var(--df-edge-label-bg);
    border: 1px solid var(--df-edge-label-border);
    border-radius: var(--df-radius-sm);
    font-size: 11px;
    color: var(--df-node-text-secondary);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    box-shadow: var(--df-edge-label-shadow);
}

/* Edge button */
.df-edge-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background: var(--df-toolbar-bg);
    color: var(--df-node-text-secondary);
    cursor: pointer;
    transition: all var(--df-transition-fast);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.df-edge-button:hover {
    background: #ef4444;
    color: white;
    transform: scale(1.1);
}

/* Connection line */
.react-flow__connection-line {
    stroke: var(--df-connection-line-stroke);
    stroke-width: var(--df-connection-line-width);
    stroke-dasharray: 5;
    animation: df-edge-flow 0.5s linear infinite;
}

/* =============================================================================
   SECTION 9: CONTROLS
   ============================================================================= */

.react-flow__controls {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: var(--df-spacing-xs);
    background: var(--df-controls-bg);
    border: 1px solid var(--df-controls-border);
    border-radius: var(--df-radius-md);
    box-shadow: var(--df-glass-shadow);
    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
}

.react-flow__controls-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: var(--df-radius-sm);
    background: transparent;
    color: var(--df-node-text);
    cursor: pointer;
    transition: all var(--df-transition-fast);
}

.react-flow__controls-button:hover {
    background: var(--df-selection-bg);
}

.react-flow__controls-button svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
}

/* =============================================================================
   SECTION 10: MINIMAP
   ============================================================================= */

.react-flow__minimap {
    background: var(--df-minimap-bg);
    border: 1px solid var(--df-controls-border);
    border-radius: var(--df-radius-md);
    box-shadow: var(--df-glass-shadow);
    backdrop-filter: blur(var(--df-glass-blur));
    -webkit-backdrop-filter: blur(var(--df-glass-blur));
    overflow: hidden;
}

.react-flow__minimap-mask {
    fill: var(--df-minimap-mask);
}

.react-flow__minimap-node {
    fill: var(--df-minimap-node-fill);
    stroke: var(--df-minimap-node-stroke);
    stroke-width: 1;
    rx: 4;
    ry: 4;
}

/* =============================================================================
   SECTION 11: SELECTION
   ============================================================================= */

.react-flow__selection {
    background: var(--df-selection-bg);
    border: 1px solid var(--df-selection-border);
    border-radius: var(--df-radius-sm);
}

.react-flow__nodesselection-rect {
    background: var(--df-selection-bg);
    border: 1px dashed var(--df-selection-border);
}

/* =============================================================================
   SECTION 12: PANELS
   ============================================================================= */

.react-flow__panel {
    margin: var(--df-spacing-md);
}

.df-panel {
    padding: var(--df-spacing-md);
    background: var(--df-glass-bg);
    border: 1px solid var(--df-glass-border);
    border-radius: var(--df-radius-md);
    box-shadow: var(--df-glass-shadow);
    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));
}

/* =============================================================================
   SECTION 13: TOOLBAR NODE
   ============================================================================= */

.df-node-toolbar {
    display: flex;
    gap: var(--df-spacing-xs);
    padding: var(--df-spacing-xs) var(--df-spacing-sm);
    background: var(--df-toolbar-bg);
    border: 1px solid var(--df-toolbar-border);
    border-radius: var(--df-radius-md);
    box-shadow: var(--df-toolbar-shadow);
    backdrop-filter: blur(8px) saturate(150%);
    -webkit-backdrop-filter: blur(8px) saturate(150%);
}

.df-toolbar-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: var(--df-radius-sm);
    background: transparent;
    color: var(--df-node-text-secondary);
    cursor: pointer;
    transition: all var(--df-transition-fast);
}

.df-toolbar-btn:hover {
    background: var(--df-selection-bg);
    color: var(--df-node-text);
}

.df-toolbar-btn.danger:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

/* =============================================================================
   SECTION 14: RESIZABLE NODE
   ============================================================================= */

.df-resizable-node {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: auto;
}

.df-resizable-node-content {
    flex: 1;
    min-height: 0;
    min-width: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
}

.df-resizable-node-content > * {
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;
    max-width: 100%;
    max-height: 100%;
    box-sizing: border-box;
}

/* Common Dash components */
.df-resizable-node-content .js-plotly-plot,
.df-resizable-node-content .plotly-graph-div {
    width: 100% !important;
    height: 100% !important;
}

.df-resizable-node-content .dash-table-container {
    width: 100%;
    height: 100%;
    overflow: auto;
}

.react-flow__resize-control {
    width: 10px;
    height: 10px;
    background: var(--df-handle-bg);
    border: 2px solid var(--df-handle-border);
    border-radius: 2px;
}

.react-flow__resize-control:hover {
    border-color: var(--df-edge-stroke-selected);
    background: var(--df-edge-stroke-selected);
}

.react-flow__resize-control.line {
    width: 4px;
    height: 4px;
    border: none;
    background: var(--df-handle-border);
    border-radius: 1px;
}

/* =============================================================================
   SECTION 15: DEVTOOLS
   ============================================================================= */

.df-devtools {
    max-height: 400px;
    overflow: auto;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
}

.df-devtools-section {
    margin-bottom: var(--df-spacing-md);
}

.df-devtools-title {
    font-weight: 600;
    margin-bottom: var(--df-spacing-xs);
    color: var(--df-node-text);
}

.df-devtools-item {
    padding: var(--df-spacing-xs) 0;
    border-bottom: 1px solid var(--df-glass-border);
}

.df-devtools-item:last-child {
    border-bottom: none;
}

/* =============================================================================
   SECTION 16: ATTRIBUTION
   ============================================================================= */

.react-flow__attribution {
    background: transparent;
    padding: var(--df-spacing-xs) var(--df-spacing-sm);
    font-size: 10px;
    color: var(--df-node-text-secondary);
    opacity: 0.6;
}

.react-flow__attribution a {
    color: inherit;
    text-decoration: none;
}

/* =============================================================================
   SECTION 17: ANIMATIONS & UTILITIES
   ============================================================================= */

@keyframes df-fade-in {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes df-scale-in {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
}

.df-animate-fade-in {
    animation: df-fade-in var(--df-transition-normal) forwards;
}

.df-animate-scale-in {
    animation: df-scale-in var(--df-transition-normal) forwards;
}

.df-no-select {
    user-select: none;
    -webkit-user-select: none;
}

.df-clickable {
    cursor: pointer;
}

.df-draggable {
    cursor: grab;
}

.df-draggable:active {
    cursor: grabbing;
}

/* =============================================================================
   SECTION 18: ACCESSIBILITY
   ============================================================================= */

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
    .df-glass-node,
    .react-flow__handle,
    .react-flow__edge-path,
    .react-flow__controls-button,
    .df-edge-button,
    .df-toolbar-btn {
        transition: none !important;
    }

    .df-glass-node:hover {
        transform: none;
    }

    .react-flow__handle:hover {
        transform: none;
    }

    .react-flow__edge.animated .react-flow__edge-path,
    .react-flow__connection-line,
    .react-flow__handle.connecting {
        animation: none;
    }
}

/* High contrast mode */
@media (prefers-contrast: high) {
    :root {
        --df-glass-bg: rgba(255, 255, 255, 0.95);
        --df-glass-blur: 4px;
        --df-glass-border: #000;
        --df-node-text: #000;
        --df-edge-stroke: #000;
    }

    .df-node-label {
        text-shadow: none;
    }

    .df-glass-node {
        border-width: 2px;
    }
}

/* Focus visible for keyboard navigation */
.df-glass-node:focus-visible,
.react-flow__handle:focus-visible,
.react-flow__controls-button:focus-visible {
    outline: 2px solid var(--df-edge-stroke-selected);
    outline-offset: 2px;
}

/* =============================================================================
   SECTION 19: FALLBACKS
   ============================================================================= */

/* Fallback for browsers without backdrop-filter support */
@supports not (backdrop-filter: blur(10px)) {
    .df-glass-node,
    .react-flow__controls,
    .react-flow__minimap,
    .df-panel,
    .df-node-toolbar {
        background: rgba(255, 255, 255, 0.95);
    }

    .react-flow.dark .df-glass-node,
    [data-mantine-color-scheme="dark"] .df-glass-node,
    .react-flow.dark .react-flow__controls,
    [data-mantine-color-scheme="dark"] .react-flow__controls,
    .react-flow.dark .react-flow__minimap,
    [data-mantine-color-scheme="dark"] .react-flow__minimap {
        background: rgba(30, 30, 30, 0.95);
    }
}

/* =============================================================================
   SECTION 20: PRINT STYLES
   ============================================================================= */

@media print {
    .react-flow__controls,
    .react-flow__minimap,
    .df-devtools {
        display: none !important;
    }

    .df-glass-node {
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        background: white;
        border: 1px solid #ccc;
        box-shadow: none;
    }

    .react-flow__edge-path {
        stroke: #000;
    }
}

/* =============================================================================
   SECTION 21: NODE STATUS INDICATORS
   ============================================================================= */

/* Status indicator colors */
:root {
    --df-status-loading-color: #3b82f6;
    --df-status-success-color: #10b981;
    --df-status-error-color: #ef4444;
    --df-status-border-width: 3px;
}

/* Base status indicator wrapper */
.df-node-status-indicator {
    position: relative;
}

/* Initial state - no special styling */
.df-node-status-initial {
    /* Default state, no additional styling */
}

/* Loading state - pulsing glow animation */
.df-status-loading,
.df-node-status-loading-border {
    position: relative;
    animation: df-loading-pulse 1.5s ease-in-out infinite;
}

/* Pulsing glow animation for loading - works with rounded corners */
@keyframes df-loading-pulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4),
                    0 0 0 0 rgba(59, 130, 246, 0.2),
                    var(--df-glass-shadow);
    }
    50% {
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.6),
                    0 0 20px 2px rgba(59, 130, 246, 0.3),
                    var(--df-glass-shadow);
    }
}

/* Spinner rotation animation */
@keyframes df-border-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Loading overlay variant */
.df-status-loading-overlay,
.df-node-status-loading-overlay {
    position: relative;
}

.df-node-status-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    z-index: 10;
}

.df-node-status-spinner {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(59, 130, 246, 0.2);
    border-top-color: var(--df-status-loading-color);
    border-radius: 50%;
    animation: df-border-spin 0.8s linear infinite;
}

/* Success state - green border with checkmark effect */
.df-status-success,
.df-node-status-success {
    position: relative;
    box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-success-color),
                var(--df-glass-shadow);
    animation: df-success-pulse 0.5s ease-out;
}

.df-status-success::after,
.df-node-status-success::after {
    content: '✓';
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    background: var(--df-status-success-color);
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

@keyframes df-success-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5),
                    var(--df-glass-shadow);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.2),
                    var(--df-glass-shadow);
    }
    100% {
        box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-success-color),
                    var(--df-glass-shadow);
    }
}

/* Error state - red border with X */
.df-status-error,
.df-node-status-error {
    position: relative;
    box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-error-color),
                var(--df-glass-shadow);
    animation: df-error-shake 0.4s ease-out;
}

.df-status-error::after,
.df-node-status-error::after {
    content: '✕';
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    background: var(--df-status-error-color);
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

@keyframes df-error-shake {
    0%, 100% {
        transform: translateX(0);
    }
    20%, 60% {
        transform: translateX(-4px);
    }
    40%, 80% {
        transform: translateX(4px);
    }
}

/* Dark mode adjustments */
.dark .df-node-status-overlay,
[data-mantine-color-scheme="dark"] .df-node-status-overlay {
    background: rgba(26, 27, 30, 0.8);
}

.dark .df-node-status-spinner,
[data-mantine-color-scheme="dark"] .df-node-status-spinner {
    border-color: rgba(59, 130, 246, 0.3);
    border-top-color: var(--df-status-loading-color);
}

/* Node search highlight */
.df-node-search-highlight {
    animation: df-highlight-pulse 1s ease-out;
}

@keyframes df-highlight-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
    }
    50% {
        box-shadow: 0 0 0 15px rgba(59, 130, 246, 0.3);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
    }
}`, "",{"version":3,"sources":["webpack://./src/lib/styles/glass-theme.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;;kFAEkF;;AAElF;IACI;;2EAEuE;IACvE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;;IAEzB;;2EAEuE;;IAEvE,0BAA0B;IAC1B,wCAAwC;IACxC,8CAA8C;IAC9C,2CAA2C;IAC3C,qDAAqD;IACrD,2DAA2D;IAC3D,0DAA0D;IAC1D,6DAA6D;;IAE7D,qBAAqB;IACrB,gCAAgC;IAChC,4CAA4C;IAC5C,wCAAwC;IACxC,uBAAuB;IACvB,iCAAiC;IACjC,wCAAwC;;IAExC,4BAA4B;IAC5B,6CAA6C;IAC7C,kDAAkD;IAClD,+CAA+C;IAC/C,+BAA+B;;IAE/B,8BAA8B;IAC9B,8CAA8C;IAC9C,mDAAmD;IACnD,gDAAgD;IAChD,gCAAgC;;IAEhC,2BAA2B;IAC3B,wCAAwC;IACxC,gDAAgD;IAChD,iCAAiC;;IAEjC,eAAe;IACf,4CAA4C;IAC5C,gDAAgD;;IAEhD,qBAAqB;IACrB,0CAA0C;IAC1C,uCAAuC;IACvC,kDAAkD;;IAElD,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;;IAElC,eAAe;IACf,6CAA6C;IAC7C,gDAAgD;IAChD,qDAAqD;;IAErD,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;;IAE5B,eAAe;IACf,8BAA8B;IAC9B,gCAAgC;;IAEhC,uBAAuB;IACvB,oCAAoC;IACpC,4CAA4C;IAC5C,0CAA0C;IAC1C,2CAA2C;IAC3C,+BAA+B;IAC/B,iCAAiC;;IAEjC,cAAc;IACd,2CAA2C;IAC3C,8CAA8C;IAC9C,yDAAyD;;IAEzD,oBAAoB;IACpB,2DAA2D;IAC3D,6BAA6B;;IAE7B;;2EAEuE;IACvE,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;;IAErB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;;IAEpB,gBAAgB;IAChB,wDAAwD;IACxD,0DAA0D;IAC1D,wDAAwD;;IAExD,gBAAgB;IAChB,0BAA0B;IAC1B,kDAAkD;IAClD,oDAAoD;IACpD,qDAAqD;;IAErD;;2EAEuE;IACvE,+CAA+C;IAC/C,2DAA2D;IAC3D,iEAAiE;IACjE,oEAAoE;IACpE,yEAAyE;IACzE,qDAAqD;IACrD,yDAAyD;IACzD,4CAA4C;IAC5C,yDAAyD;IACzD,yDAAyD;IACzD,wEAAwE;IACxE,wEAAwE;IACxE,yEAAyE;IACzE,2DAA2D;IAC3D,+DAA+D;IAC/D,oEAAoE;IACpE,oEAAoE;IACpE,oEAAoE;AACxE;;AAEA;;;;;;;kFAOkF;;AAElF,yBAAyB;AACzB;;;;;;;IAOI,6BAA6B;IAC7B,qCAAqC;IACrC,2CAA2C;IAC3C,4CAA4C;IAC5C,iDAAiD;IACjD,sDAAsD;IACtD,2DAA2D;IAC3D,4DAA4D;;IAE5D,4BAA4B;IAC5B,gCAAgC;IAChC,4CAA4C;IAC5C,wCAAwC;IACxC,uBAAuB;IACvB,iCAAiC;IACjC,wCAAwC;;IAExC,iCAAiC;IACjC,yCAAyC;IACzC,8CAA8C;IAC9C,gDAAgD;IAChD,+BAA+B;;IAE/B,mCAAmC;IACnC,4CAA4C;IAC5C,iDAAiD;IACjD,iDAAiD;IACjD,gCAAgC;;IAEhC,iBAAiB;IACjB,wCAAwC;IACxC,gDAAgD;IAChD,iCAAiC;;IAEjC,oBAAoB;IACpB,yCAAyC;IACzC,gDAAgD;;IAEhD,iBAAiB;IACjB,uCAAuC;IACvC,6CAA6C;IAC7C,kDAAkD;;IAElD,qBAAqB;IACrB,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;;IAElC,oBAAoB;IACpB,yCAAyC;IACzC,gDAAgD;IAChD,oDAAoD;;IAEpD,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;;IAE7B,oBAAoB;IACpB,8BAA8B;IAC9B,gCAAgC;;IAEhC,4BAA4B;IAC5B,oCAAoC;IACpC,4CAA4C;IAC5C,uCAAuC;IACvC,0CAA0C;IAC1C,+BAA+B;IAC/B,iCAAiC;;IAEjC,mBAAmB;IACnB,2CAA2C;IAC3C,8CAA8C;;IAE9C,yBAAyB;IACzB,2DAA2D;AAC/D;;AAEA;;;;;;;kFAOkF;;AAElF,kDAAkD;AAClD;IACI,iCAAiC;AACrC;;AAEA,6DAA6D;AAC7D;;IAEI,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,+EAA+E;IAC/E,gGAAgG;IAChG,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,kCAAkC;IAClC,gCAAgC;IAChC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;;;IAGI,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,6EAA6E;IAC7E,+FAA+F;IAC/F,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,kCAAkC;IAClC,gCAAgC;IAChC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA,gEAAgE;AAChE;;IAEI,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;IACxC,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,kDAAkD;IAClD,+BAA+B;IAC/B,gCAAgC;IAChC,mDAAmD;IACnD,gCAAgC;IAChC,iCAAiC;IACjC,iCAAiC;IACjC,yBAAyB;IACzB,4BAA4B;IAC5B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,8CAA8C;IAC9C,0BAA0B;IAC1B,yBAAyB;IACzB,6CAA6C;IAC7C,yBAAyB;IACzB,+BAA+B;IAC/B,kDAAkD;IAClD,+BAA+B;IAC/B,gCAAgC;IAChC,oDAAoD;IACpD,gCAAgC;IAChC,iCAAiC;IACjC,iCAAiC;IACjC,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;;;;;;;;kFAUkF;;AAElF,8CAA8C;AAC9C;IACI,wBAAwB;AAC5B;;AAEA,4BAA4B;AAC5B;;IAEI,6CAA6C;IAC7C,kDAAkD;IAClD,8CAA8C;IAC9C,+BAA+B;IAC/B,8CAA8C;IAC9C,mDAAmD;IACnD,gDAAgD;IAChD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,0CAA0C;IAC1C,6CAA6C;IAC7C,0CAA0C;IAC1C,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,2CAA2C;IAC3C,gDAAgD;IAChD,gDAAgD;IAChD,+BAA+B;IAC/B,4CAA4C;IAC5C,iDAAiD;IACjD,iDAAiD;IACjD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA,+BAA+B;AAC/B;;IAEI,6CAA6C;IAC7C,kDAAkD;IAClD,8CAA8C;IAC9C,+BAA+B;IAC/B,8CAA8C;IAC9C,mDAAmD;IACnD,8CAA8C;IAC9C,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,0CAA0C;IAC1C,6CAA6C;IAC7C,0CAA0C;IAC1C,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,2CAA2C;IAC3C,gDAAgD;IAChD,gDAAgD;IAChD,+BAA+B;IAC/B,4CAA4C;IAC5C,iDAAiD;IACjD,iDAAiD;IACjD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B;;IAEI,6CAA6C;IAC7C,kDAAkD;IAClD,+CAA+C;IAC/C,+BAA+B;IAC/B,8CAA8C;IAC9C,mDAAmD;IACnD,+CAA+C;IAC/C,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,2CAA2C;IAC3C,8CAA8C;IAC9C,2CAA2C;IAC3C,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,2CAA2C;IAC3C,gDAAgD;IAChD,gDAAgD;IAChD,+BAA+B;IAC/B,4CAA4C;IAC5C,iDAAiD;IACjD,kDAAkD;IAClD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA,sCAAsC;AACtC;;IAEI,6CAA6C;IAC7C,kDAAkD;IAClD,+CAA+C;IAC/C,+BAA+B;IAC/B,8CAA8C;IAC9C,mDAAmD;IACnD,gDAAgD;IAChD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,2CAA2C;IAC3C,8CAA8C;IAC9C,2CAA2C;IAC3C,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,2CAA2C;IAC3C,gDAAgD;IAChD,iDAAiD;IACjD,+BAA+B;IAC/B,6CAA6C;IAC7C,kDAAkD;IAClD,kDAAkD;IAClD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA,0BAA0B;AAC1B;;IAEI,6CAA6C;IAC7C,kDAAkD;IAClD,8CAA8C;IAC9C,+BAA+B;IAC/B,8CAA8C;IAC9C,mDAAmD;IACnD,gDAAgD;IAChD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,0CAA0C;IAC1C,6CAA6C;IAC7C,0CAA0C;IAC1C,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,2CAA2C;IAC3C,gDAAgD;IAChD,iDAAiD;IACjD,+BAA+B;IAC/B,4CAA4C;IAC5C,iDAAiD;IACjD,kDAAkD;IAClD,gCAAgC;IAChC,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;kFAEkF;;AAElF;IACI,4CAA4C;IAC5C,8FAA8F;AAClG;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;kFAEkF;;AAElF,mCAAmC;AACnC;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA,uDAAuD;AACvD;;;IAGI,sBAAsB;IACtB,kCAAkC;IAClC,wCAAwC;IACxC,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;;;IAGI,kCAAkC;IAClC,wCAAwC;IACxC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,8EAA8E;IAC9E,sFAAsF;IACtF,6BAA6B;IAC7B,uCAAuC;IACvC,kCAAkC;IAClC,sFAAsF;IACtF,0BAA0B;IAC1B,kDAAkD;IAClD,mCAAmC;IACnC,sEAAsE;IACtE,uCAAuC;IACvC,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB;;;;gDAI4C;IAC5C,kCAAkC;IAClC,wBAAwB;IACxB,gCAAgC;IAChC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;IACnC,6FAA6F;IAC7F,yCAAyC;AAC7C;;AAEA;IACI,4CAA4C;IAC5C;;;;gCAI4B;AAChC;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mCAAmC;IACnC,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,uBAAuB;IACvB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,cAAc;AAClB;;AAEA,iEAAiE;AACjE;IACI,eAAe;IACf,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;kFAEkF;;AAElF,gCAAgC;;AAEhC,oDAAoD;AACpD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,oCAAoC;;AAEpC;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,wCAAwC;IACxC,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,gDAAgD;AAChD;IACI,wDAAwD;AAC5D;;AAEA;IACI,2DAA2D;AAC/D;;AAEA,oCAAoC;;AAEpC;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,uCAAuC;;AAEvC,oDAAoD;AACpD;IACI,0BAA0B;AAC9B;;AAEA,0CAA0C;AAC1C;IACI,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,uCAAuC;AACvC;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;kFAEkF;;AAElF,eAAe;AACf;IACI,mCAAmC;IACnC,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,uCAAuC;IACvC,0DAA0D;AAC9D;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,gBAAgB;AAChB;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,wCAAwC;IACxC,0DAA0D;AAC9D;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,iBAAiB;AACjB;IACI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA,uDAAuD;AACvD;IACI,8CAA8C;IAC9C,yDAAyD;IACzD,6CAA6C;IAC7C,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,uDAAuD;IACvD,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,uCAAuC;IACvC,yCAAyC;IACzC,UAAU;IACV,oBAAoB;IACpB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA,4CAA4C;AAC5C;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;;kFAEkF;;AAElF;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;IACX;;;;;;wCAMoC;IACpC,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,YAAY;IACZ,4CAA4C;IAC5C,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC,gCAAgC,gBAAgB,EAAE;AAClD,mCAAmC,mBAAmB,EAAE;AACxD,iCAAiC,iBAAiB,EAAE;AACpD,kCAAkC,kBAAkB,EAAE;;AAEtD,qBAAqB;AACrB,0BAA0B,SAAS,EAAE;AACrC,6BAA6B,YAAY,EAAE;AAC3C,2BAA2B,UAAU,EAAE;AACvC,4BAA4B,WAAW,EAAE;;AAEzC,4BAA4B;AAC5B;;;IAGI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4CAA4C;IAC5C,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;AACtD;;AAEA,+BAA+B;AAC/B;IACI,qCAAqC;IACrC,uCAAuC;IACvC,4CAA4C;AAChD;;AAEA,qBAAqB;AACrB;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,WAAW,2CAA2C,EAAE;IACxD,MAAM,4CAA4C,EAAE;AACxD;;AAEA;;kFAEkF;;AAElF;IACI,6BAA6B;IAC7B,yCAAyC;IACzC,UAAU;IACV,oFAAoF;AACxF;;AAEA;;IAEI,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,sCAAsC;IACtC,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,OAAO,qBAAqB,EAAE;IAC9B,KAAK,oBAAoB,EAAE;AAC/B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kDAAkD;IAClD,mCAAmC;IACnC,6CAA6C;IAC7C,kCAAkC;IAClC,eAAe;IACf,oCAAoC;IACpC,0BAA0B;IAC1B,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,oCAAoC;IACpC,eAAe;IACf,yCAAyC;IACzC,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,wCAAwC;IACxC,6CAA6C;IAC7C,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;;kFAEkF;;AAElF;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,6BAA6B;IAC7B,iCAAiC;IACjC,2CAA2C;IAC3C,kCAAkC;IAClC,kCAAkC;IAClC,8EAA8E;IAC9E,sFAAsF;AAC1F;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;kFAEkF;;AAElF;IACI,gCAAgC;IAChC,2CAA2C;IAC3C,kCAAkC;IAClC,kCAAkC;IAClC,2CAA2C;IAC3C,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,eAAe;IACf,KAAK;IACL,KAAK;AACT;;AAEA;;kFAEkF;;AAElF;IACI,kCAAkC;IAClC,4CAA4C;IAC5C,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;;kFAEkF;;AAElF;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;IACxC,kCAAkC;IAClC,kCAAkC;IAClC,8EAA8E;IAC9E,sFAAsF;AAC1F;;AAEA;;kFAEkF;;AAElF;IACI,aAAa;IACb,yBAAyB;IACzB,kDAAkD;IAClD,gCAAgC;IAChC,0CAA0C;IAC1C,kCAAkC;IAClC,oCAAoC;IACpC,yCAAyC;IACzC,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,oCAAoC;IACpC,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;;kFAEkF;;AAElF;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;;kFAEkF;;AAElF;IACI,iBAAiB;IACjB,cAAc;IACd,6EAA6E;IAC7E,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;kFAEkF;;AAElF;IACI,uBAAuB;IACvB,kDAAkD;IAClD,eAAe;IACf,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;kFAEkF;;AAElF;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE,qBAAqB,EAAE;IAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;kFAEkF;;AAElF,mBAAmB;AACnB;IACI;;;;;;QAMI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,wCAAwC;QACxC,oBAAoB;QACpB,uBAAuB;QACvB,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,0CAA0C;AAC1C;;;IAGI,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;;kFAEkF;;AAElF,0DAA0D;AAC1D;IACI;;;;;QAKI,qCAAqC;IACzC;;IAEA;;;;;;QAMI,kCAAkC;IACtC;AACJ;;AAEA;;kFAEkF;;AAElF;IACI;;;QAGI,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;QACrB,6BAA6B;QAC7B,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;;kFAEkF;;AAElF,4BAA4B;AAC5B;IACI,kCAAkC;IAClC,kCAAkC;IAClC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,yCAAyC;AAC7C;;AAEA,2CAA2C;AAC3C;;IAEI,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA,oEAAoE;AACpE;IACI;QACI;;0CAEkC;IACtC;IACA;QACI;;0CAEkC;IACtC;AACJ;;AAEA,+BAA+B;AAC/B;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,4BAA4B;AAC5B;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,gDAAgD;IAChD,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA,uDAAuD;AACvD;;IAEI,kBAAkB;IAClB;sCACkC;IAClC,yCAAyC;AAC7C;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI;QACI;0CACkC;IACtC;IACA;QACI;0CACkC;IACtC;IACA;QACI;0CACkC;IACtC;AACJ;;AAEA,oCAAoC;AACpC;;IAEI,kBAAkB;IAClB;sCACkC;IAClC,uCAAuC;AAC3C;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,0BAA0B;AAC1B;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA,0BAA0B;AAC1B;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,8CAA8C;IAClD;IACA;QACI,yCAAyC;IAC7C;AACJ","sourcesContent":["/*\n * Dash Flows Enhanced Theme System\n *\n * A comprehensive theming stylesheet with:\n * - React Flow colorMode integration (.dark/.light classes)\n * - Mantine color scheme support (data-mantine-color-scheme)\n * - CSS custom properties for programmatic theming\n * - Glass morphism effects with accessibility fallbacks\n * - Theme presets (glass, solid, minimal)\n * - Color schemes (default, ocean, forest, sunset, midnight, rose)\n *\n * Compatible with dash-mantine-components and React Flow 12+\n */\n\n/* =============================================================================\n   SECTION 1: CSS CUSTOM PROPERTIES (Theme Variables)\n   ============================================================================= */\n\n:root {\n    /* ------------------------------------------------------------------\n       Glass Effect Properties\n       ------------------------------------------------------------------ */\n    --df-glass-blur: 12px;\n    --df-glass-blur-light: 8px;\n    --df-glass-blur-heavy: 20px;\n    --df-glass-saturate: 180%;\n\n    /* ------------------------------------------------------------------\n       Theme Colors - Light Mode (Default)\n       ------------------------------------------------------------------ */\n\n    /* Base glass appearance */\n    --df-glass-bg: rgba(255, 255, 255, 0.72);\n    --df-glass-bg-hover: rgba(255, 255, 255, 0.85);\n    --df-glass-border: rgba(255, 255, 255, 0.5);\n    --df-glass-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);\n    --df-glass-shadow-hover: 0 8px 32px rgba(31, 38, 135, 0.25);\n    --df-glass-inset: inset 0 1px 0 0 rgba(255, 255, 255, 0.6);\n    --df-glass-inset-bottom: inset 0 -1px 0 0 rgba(0, 0, 0, 0.02);\n\n    /* Node base colors */\n    --df-node-bg: var(--df-glass-bg);\n    --df-node-bg-hover: var(--df-glass-bg-hover);\n    --df-node-border: var(--df-glass-border);\n    --df-node-text: #1a1b1e;\n    --df-node-text-secondary: #495057;\n    --df-node-shadow: var(--df-glass-shadow);\n\n    /* Input node - Green tint */\n    --df-input-node-bg: rgba(209, 250, 229, 0.65);\n    --df-input-node-bg-hover: rgba(209, 250, 229, 0.8);\n    --df-input-node-border: rgba(16, 185, 129, 0.3);\n    --df-input-node-accent: #10b981;\n\n    /* Output node - Purple tint */\n    --df-output-node-bg: rgba(237, 233, 254, 0.65);\n    --df-output-node-bg-hover: rgba(237, 233, 254, 0.8);\n    --df-output-node-border: rgba(139, 92, 246, 0.3);\n    --df-output-node-accent: #8b5cf6;\n\n    /* Default node - Neutral */\n    --df-default-node-bg: var(--df-glass-bg);\n    --df-default-node-border: var(--df-glass-border);\n    --df-default-node-accent: #3b82f6;\n\n    /* Group node */\n    --df-group-node-bg: rgba(243, 244, 246, 0.5);\n    --df-group-node-border: rgba(156, 163, 175, 0.4);\n\n    /* Toolbar & panels */\n    --df-toolbar-bg: rgba(255, 255, 255, 0.95);\n    --df-toolbar-border: rgba(0, 0, 0, 0.1);\n    --df-toolbar-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n\n    /* Edge colors */\n    --df-edge-stroke: #64748b;\n    --df-edge-stroke-width: 2;\n    --df-edge-stroke-selected: #3b82f6;\n    --df-edge-stroke-animated: #8b5cf6;\n\n    /* Edge label */\n    --df-edge-label-bg: rgba(255, 255, 255, 0.85);\n    --df-edge-label-border: rgba(255, 255, 255, 0.6);\n    --df-edge-label-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\n    /* Handle colors */\n    --df-handle-bg: #fff;\n    --df-handle-border: #64748b;\n    --df-handle-bg-connected: #3b82f6;\n    --df-handle-bg-valid: #10b981;\n    --df-handle-size: 14px;\n    --df-handle-size-hover: 18px;\n\n    /* Background */\n    --df-background-color: #fafafa;\n    --df-background-pattern: #e5e7eb;\n\n    /* Controls & MiniMap */\n    --df-controls-bg: var(--df-glass-bg);\n    --df-controls-border: var(--df-glass-border);\n    --df-minimap-bg: rgba(255, 255, 255, 0.85);\n    --df-minimap-mask: rgba(59, 130, 246, 0.15);\n    --df-minimap-node-fill: #64748b;\n    --df-minimap-node-stroke: #475569;\n\n    /* Selection */\n    --df-selection-bg: rgba(59, 130, 246, 0.08);\n    --df-selection-border: rgba(59, 130, 246, 0.4);\n    --df-selection-ring: 0 0 0 2px var(--df-selection-border);\n\n    /* Connection line */\n    --df-connection-line-stroke: var(--df-edge-stroke-selected);\n    --df-connection-line-width: 2;\n\n    /* ------------------------------------------------------------------\n       Spacing & Sizing\n       ------------------------------------------------------------------ */\n    --df-spacing-xs: 4px;\n    --df-spacing-sm: 8px;\n    --df-spacing-md: 12px;\n    --df-spacing-lg: 16px;\n    --df-spacing-xl: 24px;\n\n    /* Border radius */\n    --df-radius-xs: 4px;\n    --df-radius-sm: 6px;\n    --df-radius-md: 10px;\n    --df-radius-lg: 14px;\n    --df-radius-xl: 20px;\n\n    /* Transitions */\n    --df-transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    --df-transition-normal: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n    --df-transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    /* Node sizing */\n    --df-node-min-width: 150px;\n    --df-node-default-width: clamp(160px, 18vw, 300px);\n    --df-group-node-min-width: clamp(220px, 22vw, 400px);\n    --df-group-node-min-height: clamp(180px, 25vh, 400px);\n\n    /* ------------------------------------------------------------------\n       Map to React Flow CSS Variables\n       ------------------------------------------------------------------ */\n    --xy-edge-stroke-default: var(--df-edge-stroke);\n    --xy-edge-stroke-width-default: var(--df-edge-stroke-width);\n    --xy-edge-stroke-selected-default: var(--df-edge-stroke-selected);\n    --xy-connectionline-stroke-default: var(--df-connection-line-stroke);\n    --xy-connectionline-stroke-width-default: var(--df-connection-line-width);\n    --xy-node-background-color-default: var(--df-node-bg);\n    --xy-node-border-default: 1px solid var(--df-node-border);\n    --xy-node-color-default: var(--df-node-text);\n    --xy-handle-background-color-default: var(--df-handle-bg);\n    --xy-handle-border-color-default: var(--df-handle-border);\n    --xy-background-pattern-dots-color-default: var(--df-background-pattern);\n    --xy-background-pattern-line-color-default: var(--df-background-pattern);\n    --xy-background-pattern-cross-color-default: var(--df-background-pattern);\n    --xy-minimap-background-color-default: var(--df-minimap-bg);\n    --xy-selection-background-color-default: var(--df-selection-bg);\n    --xy-selection-border-default: 1px dotted var(--df-selection-border);\n    --xy-controls-button-background-color-default: var(--df-controls-bg);\n    --xy-controls-button-border-color-default: var(--df-controls-border);\n}\n\n/* =============================================================================\n   SECTION 2: DARK MODE VARIABLES\n\n   Supports multiple dark mode detection methods:\n   - React Flow colorMode=\"dark\" adds .dark class\n   - Mantine uses data-mantine-color-scheme=\"dark\"\n   - Custom data-theme=\"dark\" attribute\n   ============================================================================= */\n\n/* React Flow dark mode */\n.react-flow.dark,\n/* Mantine dark mode */\n:root[data-mantine-color-scheme=\"dark\"],\n[data-mantine-color-scheme=\"dark\"],\n/* Custom dark mode class */\n.dark-mode,\n[data-theme=\"dark\"] {\n    /* Glass effect - Dark mode */\n    --df-glass-bg: rgba(26, 27, 30, 0.72);\n    --df-glass-bg-hover: rgba(37, 38, 43, 0.85);\n    --df-glass-border: rgba(255, 255, 255, 0.08);\n    --df-glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);\n    --df-glass-shadow-hover: 0 8px 32px rgba(0, 0, 0, 0.5);\n    --df-glass-inset: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);\n    --df-glass-inset-bottom: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n\n    /* Node colors - Dark mode */\n    --df-node-bg: var(--df-glass-bg);\n    --df-node-bg-hover: var(--df-glass-bg-hover);\n    --df-node-border: var(--df-glass-border);\n    --df-node-text: #f1f3f5;\n    --df-node-text-secondary: #909296;\n    --df-node-shadow: var(--df-glass-shadow);\n\n    /* Input node - Green tint dark */\n    --df-input-node-bg: rgba(6, 78, 59, 0.45);\n    --df-input-node-bg-hover: rgba(6, 78, 59, 0.6);\n    --df-input-node-border: rgba(16, 185, 129, 0.25);\n    --df-input-node-accent: #34d399;\n\n    /* Output node - Purple tint dark */\n    --df-output-node-bg: rgba(76, 29, 149, 0.35);\n    --df-output-node-bg-hover: rgba(76, 29, 149, 0.5);\n    --df-output-node-border: rgba(139, 92, 246, 0.25);\n    --df-output-node-accent: #a78bfa;\n\n    /* Default node */\n    --df-default-node-bg: var(--df-glass-bg);\n    --df-default-node-border: var(--df-glass-border);\n    --df-default-node-accent: #60a5fa;\n\n    /* Group node dark */\n    --df-group-node-bg: rgba(55, 65, 81, 0.4);\n    --df-group-node-border: rgba(107, 114, 128, 0.4);\n\n    /* Toolbar dark */\n    --df-toolbar-bg: rgba(37, 38, 43, 0.95);\n    --df-toolbar-border: rgba(255, 255, 255, 0.1);\n    --df-toolbar-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n\n    /* Edge colors dark */\n    --df-edge-stroke: #94a3b8;\n    --df-edge-stroke-selected: #60a5fa;\n    --df-edge-stroke-animated: #a78bfa;\n\n    /* Edge label dark */\n    --df-edge-label-bg: rgba(37, 38, 43, 0.9);\n    --df-edge-label-border: rgba(255, 255, 255, 0.1);\n    --df-edge-label-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n    /* Handle colors dark */\n    --df-handle-bg: #25262b;\n    --df-handle-border: #94a3b8;\n    --df-handle-bg-connected: #60a5fa;\n    --df-handle-bg-valid: #34d399;\n\n    /* Background dark */\n    --df-background-color: #1a1b1e;\n    --df-background-pattern: #2c2e33;\n\n    /* Controls & MiniMap dark */\n    --df-controls-bg: var(--df-glass-bg);\n    --df-controls-border: var(--df-glass-border);\n    --df-minimap-bg: rgba(26, 27, 30, 0.85);\n    --df-minimap-mask: rgba(96, 165, 250, 0.2);\n    --df-minimap-node-fill: #94a3b8;\n    --df-minimap-node-stroke: #64748b;\n\n    /* Selection dark */\n    --df-selection-bg: rgba(96, 165, 250, 0.12);\n    --df-selection-border: rgba(96, 165, 250, 0.5);\n\n    /* Connection line dark */\n    --df-connection-line-stroke: var(--df-edge-stroke-selected);\n}\n\n/* =============================================================================\n   SECTION 3: THEME PRESETS\n\n   Apply these classes to the DashFlows container:\n   - .df-theme-glass (default)\n   - .df-theme-solid\n   - .df-theme-minimal\n   ============================================================================= */\n\n/* Glass Theme (Default) - Already defined above */\n.df-theme-glass {\n    /* Uses default glass variables */\n}\n\n/* Solid Theme - No transparency, opaque cards with shadows */\n.df-theme-solid,\n.df-theme-solid .react-flow {\n    --df-glass-blur: 0px;\n    --df-glass-saturate: 100%;\n    --df-glass-bg: #ffffff;\n    --df-glass-bg-hover: #f8fafc;\n    --df-glass-border: #e2e8f0;\n    --df-glass-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);\n    --df-glass-shadow-hover: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n    --df-glass-inset: none;\n    --df-glass-inset-bottom: none;\n    --df-node-bg: #ffffff;\n    --df-node-bg-hover: #f8fafc;\n    --df-node-border: #e2e8f0;\n    --df-input-node-bg: #dcfce7;\n    --df-input-node-bg-hover: #bbf7d0;\n    --df-input-node-border: #86efac;\n    --df-output-node-bg: #f3e8ff;\n    --df-output-node-bg-hover: #e9d5ff;\n    --df-output-node-border: #c4b5fd;\n    --df-default-node-bg: #ffffff;\n    --df-default-node-border: #e2e8f0;\n    --df-controls-bg: #ffffff;\n    --df-minimap-bg: #ffffff;\n    --df-toolbar-bg: #ffffff;\n    --df-edge-label-bg: #ffffff;\n    --df-background-color: #f8fafc;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-theme-solid,\n[data-mantine-color-scheme=\"dark\"] .df-theme-solid .react-flow,\n.df-theme-solid .react-flow.dark {\n    --df-glass-bg: #1e1e1e;\n    --df-glass-bg-hover: #2d2d2d;\n    --df-glass-border: #404040;\n    --df-glass-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);\n    --df-glass-shadow-hover: 0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3);\n    --df-node-bg: #1e1e1e;\n    --df-node-bg-hover: #2d2d2d;\n    --df-node-border: #404040;\n    --df-input-node-bg: #14532d;\n    --df-input-node-bg-hover: #166534;\n    --df-input-node-border: #22c55e;\n    --df-output-node-bg: #581c87;\n    --df-output-node-bg-hover: #6b21a8;\n    --df-output-node-border: #a855f7;\n    --df-default-node-bg: #1e1e1e;\n    --df-default-node-border: #404040;\n    --df-controls-bg: #1e1e1e;\n    --df-minimap-bg: #1e1e1e;\n    --df-toolbar-bg: #1e1e1e;\n    --df-edge-label-bg: #1e1e1e;\n    --df-background-color: #121212;\n    --df-background-pattern: #2a2a2a;\n}\n\n/* Minimal Theme - Clean lines, subtle styling, border-focused */\n.df-theme-minimal,\n.df-theme-minimal .react-flow {\n    --df-glass-blur: 0px;\n    --df-glass-saturate: 100%;\n    --df-glass-bg: transparent;\n    --df-glass-bg-hover: rgba(0, 0, 0, 0.03);\n    --df-glass-border: #d1d5db;\n    --df-glass-shadow: none;\n    --df-glass-shadow-hover: none;\n    --df-glass-inset: none;\n    --df-glass-inset-bottom: none;\n    --df-radius-lg: 6px;\n    --df-radius-xl: 8px;\n    --df-node-bg: transparent;\n    --df-node-bg-hover: rgba(0, 0, 0, 0.03);\n    --df-node-border: #d1d5db;\n    --df-node-shadow: none;\n    --df-input-node-bg: transparent;\n    --df-input-node-bg-hover: rgba(16, 185, 129, 0.05);\n    --df-input-node-border: #10b981;\n    --df-output-node-bg: transparent;\n    --df-output-node-bg-hover: rgba(139, 92, 246, 0.05);\n    --df-output-node-border: #8b5cf6;\n    --df-default-node-bg: transparent;\n    --df-default-node-border: #d1d5db;\n    --df-toolbar-shadow: none;\n    --df-edge-label-shadow: none;\n    --df-background-color: #ffffff;\n    --df-background-pattern: #f3f4f6;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-theme-minimal,\n[data-mantine-color-scheme=\"dark\"] .df-theme-minimal .react-flow,\n.df-theme-minimal .react-flow.dark {\n    --df-glass-bg-hover: rgba(255, 255, 255, 0.03);\n    --df-glass-border: #4b5563;\n    --df-node-bg: transparent;\n    --df-node-bg-hover: rgba(255, 255, 255, 0.03);\n    --df-node-border: #4b5563;\n    --df-input-node-bg: transparent;\n    --df-input-node-bg-hover: rgba(52, 211, 153, 0.08);\n    --df-input-node-border: #34d399;\n    --df-output-node-bg: transparent;\n    --df-output-node-bg-hover: rgba(167, 139, 250, 0.08);\n    --df-output-node-border: #a78bfa;\n    --df-default-node-bg: transparent;\n    --df-default-node-border: #4b5563;\n    --df-background-color: #111827;\n    --df-background-pattern: #1f2937;\n}\n\n/* =============================================================================\n   SECTION 3B: COLOR SCHEMES\n\n   Apply these classes to the DashFlows container:\n   - .df-scheme-default (neutral blue/purple)\n   - .df-scheme-ocean (blues and teals)\n   - .df-scheme-forest (greens and browns)\n   - .df-scheme-sunset (oranges and reds)\n   - .df-scheme-midnight (deep blues and purples)\n   - .df-scheme-rose (pinks and reds)\n   ============================================================================= */\n\n/* Default scheme - already defined in :root */\n.df-scheme-default {\n    /* Uses default colors */\n}\n\n/* Ocean - Blues and Teals */\n.df-scheme-ocean,\n.df-scheme-ocean .react-flow {\n    --df-input-node-bg: rgba(207, 250, 254, 0.65);\n    --df-input-node-bg-hover: rgba(207, 250, 254, 0.8);\n    --df-input-node-border: rgba(6, 182, 212, 0.3);\n    --df-input-node-accent: #06b6d4;\n    --df-output-node-bg: rgba(219, 234, 254, 0.65);\n    --df-output-node-bg-hover: rgba(219, 234, 254, 0.8);\n    --df-output-node-border: rgba(59, 130, 246, 0.3);\n    --df-output-node-accent: #3b82f6;\n    --df-default-node-accent: #0891b2;\n    --df-edge-stroke: #0891b2;\n    --df-edge-stroke-selected: #06b6d4;\n    --df-edge-stroke-animated: #0ea5e9;\n    --df-handle-bg-connected: #06b6d4;\n    --df-handle-bg-valid: #14b8a6;\n    --df-selection-bg: rgba(6, 182, 212, 0.08);\n    --df-selection-border: rgba(6, 182, 212, 0.4);\n    --df-minimap-mask: rgba(6, 182, 212, 0.15);\n    --df-background-color: #f0f9ff;\n    --df-background-pattern: #bae6fd;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-scheme-ocean,\n[data-mantine-color-scheme=\"dark\"] .df-scheme-ocean .react-flow,\n.df-scheme-ocean .react-flow.dark {\n    --df-input-node-bg: rgba(8, 145, 178, 0.35);\n    --df-input-node-bg-hover: rgba(8, 145, 178, 0.5);\n    --df-input-node-border: rgba(34, 211, 238, 0.25);\n    --df-input-node-accent: #22d3ee;\n    --df-output-node-bg: rgba(29, 78, 216, 0.35);\n    --df-output-node-bg-hover: rgba(29, 78, 216, 0.5);\n    --df-output-node-border: rgba(96, 165, 250, 0.25);\n    --df-output-node-accent: #60a5fa;\n    --df-default-node-accent: #22d3ee;\n    --df-edge-stroke: #67e8f9;\n    --df-edge-stroke-selected: #22d3ee;\n    --df-edge-stroke-animated: #38bdf8;\n    --df-handle-bg-connected: #22d3ee;\n    --df-handle-bg-valid: #2dd4bf;\n    --df-background-color: #0c1929;\n    --df-background-pattern: #164e63;\n}\n\n/* Forest - Greens and Browns */\n.df-scheme-forest,\n.df-scheme-forest .react-flow {\n    --df-input-node-bg: rgba(220, 252, 231, 0.65);\n    --df-input-node-bg-hover: rgba(220, 252, 231, 0.8);\n    --df-input-node-border: rgba(34, 197, 94, 0.3);\n    --df-input-node-accent: #22c55e;\n    --df-output-node-bg: rgba(254, 243, 199, 0.65);\n    --df-output-node-bg-hover: rgba(254, 243, 199, 0.8);\n    --df-output-node-border: rgba(161, 98, 7, 0.3);\n    --df-output-node-accent: #a16207;\n    --df-default-node-accent: #16a34a;\n    --df-edge-stroke: #65a30d;\n    --df-edge-stroke-selected: #22c55e;\n    --df-edge-stroke-animated: #84cc16;\n    --df-handle-bg-connected: #22c55e;\n    --df-handle-bg-valid: #4ade80;\n    --df-selection-bg: rgba(34, 197, 94, 0.08);\n    --df-selection-border: rgba(34, 197, 94, 0.4);\n    --df-minimap-mask: rgba(34, 197, 94, 0.15);\n    --df-background-color: #f0fdf4;\n    --df-background-pattern: #bbf7d0;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-scheme-forest,\n[data-mantine-color-scheme=\"dark\"] .df-scheme-forest .react-flow,\n.df-scheme-forest .react-flow.dark {\n    --df-input-node-bg: rgba(21, 128, 61, 0.35);\n    --df-input-node-bg-hover: rgba(21, 128, 61, 0.5);\n    --df-input-node-border: rgba(74, 222, 128, 0.25);\n    --df-input-node-accent: #4ade80;\n    --df-output-node-bg: rgba(120, 53, 15, 0.35);\n    --df-output-node-bg-hover: rgba(120, 53, 15, 0.5);\n    --df-output-node-border: rgba(251, 191, 36, 0.25);\n    --df-output-node-accent: #fbbf24;\n    --df-default-node-accent: #4ade80;\n    --df-edge-stroke: #a3e635;\n    --df-edge-stroke-selected: #4ade80;\n    --df-edge-stroke-animated: #bef264;\n    --df-handle-bg-connected: #4ade80;\n    --df-handle-bg-valid: #86efac;\n    --df-background-color: #052e16;\n    --df-background-pattern: #14532d;\n}\n\n/* Sunset - Oranges and Reds */\n.df-scheme-sunset,\n.df-scheme-sunset .react-flow {\n    --df-input-node-bg: rgba(255, 237, 213, 0.65);\n    --df-input-node-bg-hover: rgba(255, 237, 213, 0.8);\n    --df-input-node-border: rgba(249, 115, 22, 0.3);\n    --df-input-node-accent: #f97316;\n    --df-output-node-bg: rgba(254, 226, 226, 0.65);\n    --df-output-node-bg-hover: rgba(254, 226, 226, 0.8);\n    --df-output-node-border: rgba(239, 68, 68, 0.3);\n    --df-output-node-accent: #ef4444;\n    --df-default-node-accent: #ea580c;\n    --df-edge-stroke: #ea580c;\n    --df-edge-stroke-selected: #f97316;\n    --df-edge-stroke-animated: #fb923c;\n    --df-handle-bg-connected: #f97316;\n    --df-handle-bg-valid: #fb923c;\n    --df-selection-bg: rgba(249, 115, 22, 0.08);\n    --df-selection-border: rgba(249, 115, 22, 0.4);\n    --df-minimap-mask: rgba(249, 115, 22, 0.15);\n    --df-background-color: #fffbeb;\n    --df-background-pattern: #fed7aa;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-scheme-sunset,\n[data-mantine-color-scheme=\"dark\"] .df-scheme-sunset .react-flow,\n.df-scheme-sunset .react-flow.dark {\n    --df-input-node-bg: rgba(194, 65, 12, 0.35);\n    --df-input-node-bg-hover: rgba(194, 65, 12, 0.5);\n    --df-input-node-border: rgba(251, 146, 60, 0.25);\n    --df-input-node-accent: #fb923c;\n    --df-output-node-bg: rgba(185, 28, 28, 0.35);\n    --df-output-node-bg-hover: rgba(185, 28, 28, 0.5);\n    --df-output-node-border: rgba(248, 113, 113, 0.25);\n    --df-output-node-accent: #f87171;\n    --df-default-node-accent: #fb923c;\n    --df-edge-stroke: #fdba74;\n    --df-edge-stroke-selected: #fb923c;\n    --df-edge-stroke-animated: #fcd34d;\n    --df-handle-bg-connected: #fb923c;\n    --df-handle-bg-valid: #fdba74;\n    --df-background-color: #27150a;\n    --df-background-pattern: #431407;\n}\n\n/* Midnight - Deep Blues and Purples */\n.df-scheme-midnight,\n.df-scheme-midnight .react-flow {\n    --df-input-node-bg: rgba(224, 231, 255, 0.65);\n    --df-input-node-bg-hover: rgba(224, 231, 255, 0.8);\n    --df-input-node-border: rgba(99, 102, 241, 0.3);\n    --df-input-node-accent: #6366f1;\n    --df-output-node-bg: rgba(243, 232, 255, 0.65);\n    --df-output-node-bg-hover: rgba(243, 232, 255, 0.8);\n    --df-output-node-border: rgba(168, 85, 247, 0.3);\n    --df-output-node-accent: #a855f7;\n    --df-default-node-accent: #818cf8;\n    --df-edge-stroke: #6366f1;\n    --df-edge-stroke-selected: #818cf8;\n    --df-edge-stroke-animated: #a78bfa;\n    --df-handle-bg-connected: #818cf8;\n    --df-handle-bg-valid: #a78bfa;\n    --df-selection-bg: rgba(99, 102, 241, 0.08);\n    --df-selection-border: rgba(99, 102, 241, 0.4);\n    --df-minimap-mask: rgba(99, 102, 241, 0.15);\n    --df-background-color: #eef2ff;\n    --df-background-pattern: #c7d2fe;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-scheme-midnight,\n[data-mantine-color-scheme=\"dark\"] .df-scheme-midnight .react-flow,\n.df-scheme-midnight .react-flow.dark {\n    --df-input-node-bg: rgba(67, 56, 202, 0.35);\n    --df-input-node-bg-hover: rgba(67, 56, 202, 0.5);\n    --df-input-node-border: rgba(129, 140, 248, 0.25);\n    --df-input-node-accent: #818cf8;\n    --df-output-node-bg: rgba(126, 34, 206, 0.35);\n    --df-output-node-bg-hover: rgba(126, 34, 206, 0.5);\n    --df-output-node-border: rgba(192, 132, 252, 0.25);\n    --df-output-node-accent: #c084fc;\n    --df-default-node-accent: #a5b4fc;\n    --df-edge-stroke: #a5b4fc;\n    --df-edge-stroke-selected: #818cf8;\n    --df-edge-stroke-animated: #c4b5fd;\n    --df-handle-bg-connected: #818cf8;\n    --df-handle-bg-valid: #a78bfa;\n    --df-background-color: #0f0a29;\n    --df-background-pattern: #1e1b4b;\n}\n\n/* Rose - Pinks and Reds */\n.df-scheme-rose,\n.df-scheme-rose .react-flow {\n    --df-input-node-bg: rgba(255, 228, 230, 0.65);\n    --df-input-node-bg-hover: rgba(255, 228, 230, 0.8);\n    --df-input-node-border: rgba(244, 63, 94, 0.3);\n    --df-input-node-accent: #f43f5e;\n    --df-output-node-bg: rgba(252, 231, 243, 0.65);\n    --df-output-node-bg-hover: rgba(252, 231, 243, 0.8);\n    --df-output-node-border: rgba(236, 72, 153, 0.3);\n    --df-output-node-accent: #ec4899;\n    --df-default-node-accent: #fb7185;\n    --df-edge-stroke: #e11d48;\n    --df-edge-stroke-selected: #f43f5e;\n    --df-edge-stroke-animated: #fb7185;\n    --df-handle-bg-connected: #f43f5e;\n    --df-handle-bg-valid: #fb7185;\n    --df-selection-bg: rgba(244, 63, 94, 0.08);\n    --df-selection-border: rgba(244, 63, 94, 0.4);\n    --df-minimap-mask: rgba(244, 63, 94, 0.15);\n    --df-background-color: #fff1f2;\n    --df-background-pattern: #fecdd3;\n}\n\n[data-mantine-color-scheme=\"dark\"] .df-scheme-rose,\n[data-mantine-color-scheme=\"dark\"] .df-scheme-rose .react-flow,\n.df-scheme-rose .react-flow.dark {\n    --df-input-node-bg: rgba(190, 18, 60, 0.35);\n    --df-input-node-bg-hover: rgba(190, 18, 60, 0.5);\n    --df-input-node-border: rgba(251, 113, 133, 0.25);\n    --df-input-node-accent: #fb7185;\n    --df-output-node-bg: rgba(157, 23, 77, 0.35);\n    --df-output-node-bg-hover: rgba(157, 23, 77, 0.5);\n    --df-output-node-border: rgba(244, 114, 182, 0.25);\n    --df-output-node-accent: #f472b6;\n    --df-default-node-accent: #fda4af;\n    --df-edge-stroke: #fda4af;\n    --df-edge-stroke-selected: #fb7185;\n    --df-edge-stroke-animated: #f9a8d4;\n    --df-handle-bg-connected: #fb7185;\n    --df-handle-bg-valid: #fda4af;\n    --df-background-color: #1f0a14;\n    --df-background-pattern: #4c0519;\n}\n\n/* =============================================================================\n   SECTION 4: REACT FLOW CONTAINER\n   ============================================================================= */\n\n.react-flow {\n    background-color: var(--df-background-color);\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n}\n\n.react-flow__background {\n    background-color: var(--df-background-color);\n}\n\n.react-flow__background pattern circle {\n    fill: var(--df-background-pattern);\n}\n\n.react-flow__background pattern line {\n    stroke: var(--df-background-pattern);\n}\n\n/* =============================================================================\n   SECTION 5: NODE BASE STYLES\n   ============================================================================= */\n\n/* Reset React Flow node defaults */\n.react-flow__node {\n    overflow: visible !important;\n}\n\n.react-flow__node.selected,\n.react-flow__node:focus,\n.react-flow__node:focus-visible {\n    outline: none !important;\n}\n\n/* Remove React Flow's default node container styling */\n.react-flow__node-input,\n.react-flow__node-default,\n.react-flow__node-output {\n    width: auto !important;\n    background: transparent !important;\n    background-color: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n}\n\n/* Also target when selected to prevent React Flow's selected styling */\n.react-flow__node-input.selected,\n.react-flow__node-default.selected,\n.react-flow__node-output.selected {\n    background: transparent !important;\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n/* Glass Node Base */\n.df-glass-node {\n    position: relative;\n    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n    background: var(--df-node-bg);\n    border: 1px solid var(--df-node-border);\n    border-radius: var(--df-radius-lg);\n    box-shadow: var(--df-node-shadow), var(--df-glass-inset), var(--df-glass-inset-bottom);\n    color: var(--df-node-text);\n    padding: var(--df-spacing-md) var(--df-spacing-lg);\n    min-width: var(--df-node-min-width);\n    /* Use max-width instead of width for flexibility with layout system */\n    max-width: var(--df-node-default-width);\n    box-sizing: border-box;\n    overflow: visible;\n    text-align: center;\n    transition:\n        background var(--df-transition-normal),\n        box-shadow var(--df-transition-normal),\n        transform var(--df-transition-normal),\n        border-color var(--df-transition-normal);\n    will-change: transform, box-shadow;\n    transform: translateZ(0);\n    -webkit-transform: translateZ(0);\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n}\n\n.df-glass-node:hover {\n    background: var(--df-node-bg-hover);\n    box-shadow: var(--df-glass-shadow-hover), var(--df-glass-inset), var(--df-glass-inset-bottom);\n    transform: translateY(-1px) translateZ(0);\n}\n\n.df-glass-node.selected {\n    border-color: var(--df-edge-stroke-selected);\n    box-shadow:\n        var(--df-glass-shadow-hover),\n        var(--df-glass-inset),\n        var(--df-glass-inset-bottom),\n        var(--df-selection-ring);\n}\n\n/* Node content */\n.df-node-content {\n    overflow: hidden;\n}\n\n.df-node-label {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.4;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n    /* Text shadow for readability over glass */\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.df-node-label.multiline {\n    white-space: normal;\n    word-wrap: break-word;\n}\n\n.df-node-sublabel {\n    font-size: 11px;\n    color: var(--df-node-text-secondary);\n    margin-top: var(--df-spacing-xs);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Node icon container */\n.df-node-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 24px;\n    min-height: 24px;\n    width: 24px;\n    height: 24px;\n    border-radius: var(--df-radius-sm);\n    margin-bottom: var(--df-spacing-sm);\n    color: white;\n    font-size: 12px;\n    flex-shrink: 0;\n}\n\n/* Custom icon styling (for DashIconify or other Dash components) */\n.df-node-icon.df-icon-custom {\n    background: transparent;\n    color: var(--df-node-text-primary);\n    width: auto;\n    height: auto;\n    min-width: 20px;\n    min-height: 20px;\n}\n\n/* Ensure DashIconify icons inherit proper sizing */\n.df-node-icon.df-icon-custom svg {\n    display: block;\n}\n\n/* Node body text (additional description below label/sublabel) */\n.df-node-body {\n    font-size: 11px;\n    color: var(--df-node-text-secondary);\n    margin-top: var(--df-spacing-xs);\n    line-height: 1.4;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 150px;\n}\n\n.df-node-body.multiline {\n    white-space: normal;\n    word-wrap: break-word;\n    max-width: none;\n}\n\n/* =============================================================================\n   SECTION 5B: NODE LAYOUT SYSTEM\n   ============================================================================= */\n\n/* --- Base Layout Classes --- */\n\n/* Stacked layout (default) - vertical arrangement */\n.df-glass-node.df-layout-stacked {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Horizontal layout - two column arrangement */\n.df-glass-node.df-layout-horizontal {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    min-width: auto !important;\n    width: auto !important;\n    text-align: left !important;\n}\n\n/* --- Icon Only Configuration --- */\n\n.df-glass-node.df-icon-only {\n    min-width: auto !important;\n    width: auto !important;\n    padding: var(--df-spacing-sm) !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.df-glass-node.df-icon-only .df-node-icon {\n    margin: 0 !important;\n}\n\n.df-glass-node.df-icon-only .df-node-content {\n    display: none !important;\n}\n\n/* Icon only with accent bars - adjust padding */\n.df-glass-node.df-input-node.df-icon-only {\n    padding-top: calc(var(--df-spacing-sm) + 4px) !important;\n}\n\n.df-glass-node.df-output-node.df-icon-only {\n    padding-bottom: calc(var(--df-spacing-sm) + 4px) !important;\n}\n\n/* --- Text Only Configuration --- */\n\n.df-glass-node.df-text-only {\n    text-align: center;\n}\n\n.df-glass-node.df-text-only .df-node-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.df-glass-node.df-text-only .df-node-label,\n.df-glass-node.df-text-only .df-node-body {\n    text-align: center;\n}\n\n/* --- Full Content Configuration --- */\n\n/* Stacked full content - current default behavior */\n.df-glass-node.df-layout-stacked.df-full-content {\n    /* Uses existing styling */\n}\n\n/* Horizontal full content - two columns */\n.df-glass-node.df-layout-horizontal.df-full-content {\n    gap: var(--df-spacing-md);\n    padding: var(--df-spacing-sm) var(--df-spacing-md);\n}\n\n/* Icon column in horizontal layout */\n.df-node-icon-column {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.df-glass-node.df-layout-horizontal .df-node-icon-column .df-node-icon {\n    margin: 0;\n}\n\n/* Text column in horizontal layout */\n.df-node-text-column {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 0;\n    flex: 1;\n    text-align: left;\n}\n\n.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-label {\n    text-align: left;\n}\n\n.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-sublabel {\n    text-align: left;\n}\n\n.df-glass-node.df-layout-horizontal .df-node-text-column .df-node-body {\n    text-align: left;\n    margin-top: var(--df-spacing-xs);\n}\n\n/* Horizontal layout with accent bars */\n.df-glass-node.df-input-node.df-layout-horizontal {\n    padding-top: calc(var(--df-spacing-sm) + 4px);\n}\n\n.df-glass-node.df-output-node.df-layout-horizontal {\n    padding-bottom: calc(var(--df-spacing-sm) + 4px);\n}\n\n/* =============================================================================\n   SECTION 6: SPECIFIC NODE TYPES\n   ============================================================================= */\n\n/* Input Node */\n.df-glass-node.df-input-node {\n    background: var(--df-input-node-bg);\n    border-color: var(--df-input-node-border);\n    padding-top: calc(var(--df-spacing-md) + 4px);\n}\n\n.df-glass-node.df-input-node:hover {\n    background: var(--df-input-node-bg-hover);\n}\n\n.df-glass-node.df-input-node .df-node-accent-bar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: var(--df-input-node-accent);\n    border-radius: var(--df-radius-lg) var(--df-radius-lg) 0 0;\n}\n\n.df-glass-node.df-input-node .df-node-icon {\n    background: var(--df-input-node-accent);\n}\n\n/* Output Node */\n.df-glass-node.df-output-node {\n    background: var(--df-output-node-bg);\n    border-color: var(--df-output-node-border);\n    padding-bottom: calc(var(--df-spacing-md) + 4px);\n}\n\n.df-glass-node.df-output-node:hover {\n    background: var(--df-output-node-bg-hover);\n}\n\n.df-glass-node.df-output-node .df-node-accent-bar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: var(--df-output-node-accent);\n    border-radius: 0 0 var(--df-radius-lg) var(--df-radius-lg);\n}\n\n.df-glass-node.df-output-node .df-node-icon {\n    background: var(--df-output-node-accent);\n}\n\n/* Default Node */\n.df-glass-node.df-default-node {\n    background: var(--df-default-node-bg);\n    border-color: var(--df-default-node-border);\n}\n\n/* Group Node - Style the React Flow wrapper directly */\n.react-flow__node-group {\n    background: var(--df-group-node-bg) !important;\n    border: 2px dashed var(--df-group-node-border) !important;\n    border-radius: var(--df-radius-lg) !important;\n    padding: 0 !important;\n    z-index: 0 !important;\n}\n\n.react-flow__node-group.selected {\n    border: 2px solid var(--df-selection-border) !important;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    z-index: 0 !important;\n}\n\n/* Group node label badge */\n.df-group-node-label {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    background: var(--df-toolbar-bg);\n    padding: 4px 10px;\n    border-radius: var(--df-radius-sm);\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--df-node-text-secondary);\n    border: 1px solid var(--df-node-border);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n    z-index: 1;\n    pointer-events: none;\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n}\n\n/* Resize handles - only show on selection */\n.react-flow__node-group .react-flow__resize-control {\n    opacity: 0;\n    transition: opacity 150ms ease;\n}\n\n.react-flow__node-group.selected .react-flow__resize-control {\n    opacity: 1;\n}\n\n/* =============================================================================\n   SECTION 7: HANDLES\n   ============================================================================= */\n\n.react-flow__handle {\n    width: var(--df-handle-size);\n    height: var(--df-handle-size);\n    background: var(--df-handle-bg);\n    border: 2px solid var(--df-handle-border);\n    border-radius: 50%;\n    z-index: 10;\n    transition:\n        width var(--df-transition-fast),\n        height var(--df-transition-fast),\n        border-color var(--df-transition-fast),\n        background var(--df-transition-fast),\n        box-shadow var(--df-transition-fast),\n        margin var(--df-transition-fast);\n    box-sizing: content-box;\n}\n\n/* Invisible hit area */\n.react-flow__handle::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 24px;\n    height: 24px;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n}\n\n.react-flow__handle:hover {\n    width: var(--df-handle-size-hover);\n    height: var(--df-handle-size-hover);\n    margin: -2px;\n    border-color: var(--df-edge-stroke-selected);\n    box-shadow: 0 0 12px rgba(59, 130, 246, 0.5);\n    cursor: crosshair;\n}\n\n/* Position-specific hover adjustments */\n.react-flow__handle-top:hover { margin-top: -5px; }\n.react-flow__handle-bottom:hover { margin-bottom: -5px; }\n.react-flow__handle-left:hover { margin-left: -5px; }\n.react-flow__handle-right:hover { margin-right: -5px; }\n\n/* Handle positions */\n.react-flow__handle-top { top: -7px; }\n.react-flow__handle-bottom { bottom: -7px; }\n.react-flow__handle-left { left: -7px; }\n.react-flow__handle-right { right: -7px; }\n\n/* Active/connecting state */\n.react-flow__handle:active,\n.react-flow__handle.connectingfrom,\n.react-flow__handle.connectingto {\n    width: 20px;\n    height: 20px;\n    margin: -3px;\n    border-color: var(--df-edge-stroke-selected);\n    box-shadow: 0 0 16px rgba(59, 130, 246, 0.6);\n}\n\n.react-flow__handle.connecting {\n    animation: df-handle-pulse 1s ease-in-out infinite;\n}\n\n/* Valid connection indicator */\n.react-flow__handle.valid {\n    background: var(--df-handle-bg-valid);\n    border-color: var(--df-handle-bg-valid);\n    box-shadow: 0 0 12px rgba(16, 185, 129, 0.5);\n}\n\n/* Connected handle */\n.react-flow__handle.connected {\n    background: var(--df-handle-bg-connected);\n    border-color: var(--df-handle-bg-connected);\n}\n\n@keyframes df-handle-pulse {\n    0%, 100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4); }\n    50% { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0); }\n}\n\n/* =============================================================================\n   SECTION 8: EDGES\n   ============================================================================= */\n\n.react-flow__edge-path {\n    stroke: var(--df-edge-stroke);\n    stroke-width: var(--df-edge-stroke-width);\n    fill: none;\n    transition: stroke var(--df-transition-fast), stroke-width var(--df-transition-fast);\n}\n\n.react-flow__edge:hover .react-flow__edge-path,\n.react-flow__edge.selected .react-flow__edge-path {\n    stroke: var(--df-edge-stroke-selected);\n    stroke-width: 2.5;\n}\n\n/* Animated edge */\n.react-flow__edge.animated .react-flow__edge-path {\n    stroke: var(--df-edge-stroke-animated);\n    stroke-dasharray: 5;\n    animation: df-edge-flow 0.5s linear infinite;\n}\n\n@keyframes df-edge-flow {\n    from { stroke-dashoffset: 10; }\n    to { stroke-dashoffset: 0; }\n}\n\n/* Edge label */\n.df-edge-label {\n    display: flex;\n    align-items: center;\n    gap: var(--df-spacing-xs);\n    padding: var(--df-spacing-xs) var(--df-spacing-sm);\n    background: var(--df-edge-label-bg);\n    border: 1px solid var(--df-edge-label-border);\n    border-radius: var(--df-radius-sm);\n    font-size: 11px;\n    color: var(--df-node-text-secondary);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    box-shadow: var(--df-edge-label-shadow);\n}\n\n/* Edge button */\n.df-edge-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border: none;\n    border-radius: 50%;\n    background: var(--df-toolbar-bg);\n    color: var(--df-node-text-secondary);\n    cursor: pointer;\n    transition: all var(--df-transition-fast);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.df-edge-button:hover {\n    background: #ef4444;\n    color: white;\n    transform: scale(1.1);\n}\n\n/* Connection line */\n.react-flow__connection-line {\n    stroke: var(--df-connection-line-stroke);\n    stroke-width: var(--df-connection-line-width);\n    stroke-dasharray: 5;\n    animation: df-edge-flow 0.5s linear infinite;\n}\n\n/* =============================================================================\n   SECTION 9: CONTROLS\n   ============================================================================= */\n\n.react-flow__controls {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding: var(--df-spacing-xs);\n    background: var(--df-controls-bg);\n    border: 1px solid var(--df-controls-border);\n    border-radius: var(--df-radius-md);\n    box-shadow: var(--df-glass-shadow);\n    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n}\n\n.react-flow__controls-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border: none;\n    border-radius: var(--df-radius-sm);\n    background: transparent;\n    color: var(--df-node-text);\n    cursor: pointer;\n    transition: all var(--df-transition-fast);\n}\n\n.react-flow__controls-button:hover {\n    background: var(--df-selection-bg);\n}\n\n.react-flow__controls-button svg {\n    width: 16px;\n    height: 16px;\n    fill: currentColor;\n}\n\n/* =============================================================================\n   SECTION 10: MINIMAP\n   ============================================================================= */\n\n.react-flow__minimap {\n    background: var(--df-minimap-bg);\n    border: 1px solid var(--df-controls-border);\n    border-radius: var(--df-radius-md);\n    box-shadow: var(--df-glass-shadow);\n    backdrop-filter: blur(var(--df-glass-blur));\n    -webkit-backdrop-filter: blur(var(--df-glass-blur));\n    overflow: hidden;\n}\n\n.react-flow__minimap-mask {\n    fill: var(--df-minimap-mask);\n}\n\n.react-flow__minimap-node {\n    fill: var(--df-minimap-node-fill);\n    stroke: var(--df-minimap-node-stroke);\n    stroke-width: 1;\n    rx: 4;\n    ry: 4;\n}\n\n/* =============================================================================\n   SECTION 11: SELECTION\n   ============================================================================= */\n\n.react-flow__selection {\n    background: var(--df-selection-bg);\n    border: 1px solid var(--df-selection-border);\n    border-radius: var(--df-radius-sm);\n}\n\n.react-flow__nodesselection-rect {\n    background: var(--df-selection-bg);\n    border: 1px dashed var(--df-selection-border);\n}\n\n/* =============================================================================\n   SECTION 12: PANELS\n   ============================================================================= */\n\n.react-flow__panel {\n    margin: var(--df-spacing-md);\n}\n\n.df-panel {\n    padding: var(--df-spacing-md);\n    background: var(--df-glass-bg);\n    border: 1px solid var(--df-glass-border);\n    border-radius: var(--df-radius-md);\n    box-shadow: var(--df-glass-shadow);\n    backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n    -webkit-backdrop-filter: blur(var(--df-glass-blur)) saturate(var(--df-glass-saturate));\n}\n\n/* =============================================================================\n   SECTION 13: TOOLBAR NODE\n   ============================================================================= */\n\n.df-node-toolbar {\n    display: flex;\n    gap: var(--df-spacing-xs);\n    padding: var(--df-spacing-xs) var(--df-spacing-sm);\n    background: var(--df-toolbar-bg);\n    border: 1px solid var(--df-toolbar-border);\n    border-radius: var(--df-radius-md);\n    box-shadow: var(--df-toolbar-shadow);\n    backdrop-filter: blur(8px) saturate(150%);\n    -webkit-backdrop-filter: blur(8px) saturate(150%);\n}\n\n.df-toolbar-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border: none;\n    border-radius: var(--df-radius-sm);\n    background: transparent;\n    color: var(--df-node-text-secondary);\n    cursor: pointer;\n    transition: all var(--df-transition-fast);\n}\n\n.df-toolbar-btn:hover {\n    background: var(--df-selection-bg);\n    color: var(--df-node-text);\n}\n\n.df-toolbar-btn.danger:hover {\n    background: rgba(239, 68, 68, 0.1);\n    color: #ef4444;\n}\n\n/* =============================================================================\n   SECTION 14: RESIZABLE NODE\n   ============================================================================= */\n\n.df-resizable-node {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-width: auto;\n}\n\n.df-resizable-node-content {\n    flex: 1;\n    min-height: 0;\n    min-width: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    box-sizing: border-box;\n}\n\n.df-resizable-node-content > * {\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n    min-width: 0;\n    max-width: 100%;\n    max-height: 100%;\n    box-sizing: border-box;\n}\n\n/* Common Dash components */\n.df-resizable-node-content .js-plotly-plot,\n.df-resizable-node-content .plotly-graph-div {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.df-resizable-node-content .dash-table-container {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n}\n\n.react-flow__resize-control {\n    width: 10px;\n    height: 10px;\n    background: var(--df-handle-bg);\n    border: 2px solid var(--df-handle-border);\n    border-radius: 2px;\n}\n\n.react-flow__resize-control:hover {\n    border-color: var(--df-edge-stroke-selected);\n    background: var(--df-edge-stroke-selected);\n}\n\n.react-flow__resize-control.line {\n    width: 4px;\n    height: 4px;\n    border: none;\n    background: var(--df-handle-border);\n    border-radius: 1px;\n}\n\n/* =============================================================================\n   SECTION 15: DEVTOOLS\n   ============================================================================= */\n\n.df-devtools {\n    max-height: 400px;\n    overflow: auto;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n    font-size: 11px;\n}\n\n.df-devtools-section {\n    margin-bottom: var(--df-spacing-md);\n}\n\n.df-devtools-title {\n    font-weight: 600;\n    margin-bottom: var(--df-spacing-xs);\n    color: var(--df-node-text);\n}\n\n.df-devtools-item {\n    padding: var(--df-spacing-xs) 0;\n    border-bottom: 1px solid var(--df-glass-border);\n}\n\n.df-devtools-item:last-child {\n    border-bottom: none;\n}\n\n/* =============================================================================\n   SECTION 16: ATTRIBUTION\n   ============================================================================= */\n\n.react-flow__attribution {\n    background: transparent;\n    padding: var(--df-spacing-xs) var(--df-spacing-sm);\n    font-size: 10px;\n    color: var(--df-node-text-secondary);\n    opacity: 0.6;\n}\n\n.react-flow__attribution a {\n    color: inherit;\n    text-decoration: none;\n}\n\n/* =============================================================================\n   SECTION 17: ANIMATIONS & UTILITIES\n   ============================================================================= */\n\n@keyframes df-fade-in {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes df-scale-in {\n    from { opacity: 0; transform: scale(0.9); }\n    to { opacity: 1; transform: scale(1); }\n}\n\n.df-animate-fade-in {\n    animation: df-fade-in var(--df-transition-normal) forwards;\n}\n\n.df-animate-scale-in {\n    animation: df-scale-in var(--df-transition-normal) forwards;\n}\n\n.df-no-select {\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.df-clickable {\n    cursor: pointer;\n}\n\n.df-draggable {\n    cursor: grab;\n}\n\n.df-draggable:active {\n    cursor: grabbing;\n}\n\n/* =============================================================================\n   SECTION 18: ACCESSIBILITY\n   ============================================================================= */\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n    .df-glass-node,\n    .react-flow__handle,\n    .react-flow__edge-path,\n    .react-flow__controls-button,\n    .df-edge-button,\n    .df-toolbar-btn {\n        transition: none !important;\n    }\n\n    .df-glass-node:hover {\n        transform: none;\n    }\n\n    .react-flow__handle:hover {\n        transform: none;\n    }\n\n    .react-flow__edge.animated .react-flow__edge-path,\n    .react-flow__connection-line,\n    .react-flow__handle.connecting {\n        animation: none;\n    }\n}\n\n/* High contrast mode */\n@media (prefers-contrast: high) {\n    :root {\n        --df-glass-bg: rgba(255, 255, 255, 0.95);\n        --df-glass-blur: 4px;\n        --df-glass-border: #000;\n        --df-node-text: #000;\n        --df-edge-stroke: #000;\n    }\n\n    .df-node-label {\n        text-shadow: none;\n    }\n\n    .df-glass-node {\n        border-width: 2px;\n    }\n}\n\n/* Focus visible for keyboard navigation */\n.df-glass-node:focus-visible,\n.react-flow__handle:focus-visible,\n.react-flow__controls-button:focus-visible {\n    outline: 2px solid var(--df-edge-stroke-selected);\n    outline-offset: 2px;\n}\n\n/* =============================================================================\n   SECTION 19: FALLBACKS\n   ============================================================================= */\n\n/* Fallback for browsers without backdrop-filter support */\n@supports not (backdrop-filter: blur(10px)) {\n    .df-glass-node,\n    .react-flow__controls,\n    .react-flow__minimap,\n    .df-panel,\n    .df-node-toolbar {\n        background: rgba(255, 255, 255, 0.95);\n    }\n\n    .react-flow.dark .df-glass-node,\n    [data-mantine-color-scheme=\"dark\"] .df-glass-node,\n    .react-flow.dark .react-flow__controls,\n    [data-mantine-color-scheme=\"dark\"] .react-flow__controls,\n    .react-flow.dark .react-flow__minimap,\n    [data-mantine-color-scheme=\"dark\"] .react-flow__minimap {\n        background: rgba(30, 30, 30, 0.95);\n    }\n}\n\n/* =============================================================================\n   SECTION 20: PRINT STYLES\n   ============================================================================= */\n\n@media print {\n    .react-flow__controls,\n    .react-flow__minimap,\n    .df-devtools {\n        display: none !important;\n    }\n\n    .df-glass-node {\n        backdrop-filter: none;\n        -webkit-backdrop-filter: none;\n        background: white;\n        border: 1px solid #ccc;\n        box-shadow: none;\n    }\n\n    .react-flow__edge-path {\n        stroke: #000;\n    }\n}\n\n/* =============================================================================\n   SECTION 21: NODE STATUS INDICATORS\n   ============================================================================= */\n\n/* Status indicator colors */\n:root {\n    --df-status-loading-color: #3b82f6;\n    --df-status-success-color: #10b981;\n    --df-status-error-color: #ef4444;\n    --df-status-border-width: 3px;\n}\n\n/* Base status indicator wrapper */\n.df-node-status-indicator {\n    position: relative;\n}\n\n/* Initial state - no special styling */\n.df-node-status-initial {\n    /* Default state, no additional styling */\n}\n\n/* Loading state - pulsing glow animation */\n.df-status-loading,\n.df-node-status-loading-border {\n    position: relative;\n    animation: df-loading-pulse 1.5s ease-in-out infinite;\n}\n\n/* Pulsing glow animation for loading - works with rounded corners */\n@keyframes df-loading-pulse {\n    0%, 100% {\n        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4),\n                    0 0 0 0 rgba(59, 130, 246, 0.2),\n                    var(--df-glass-shadow);\n    }\n    50% {\n        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.6),\n                    0 0 20px 2px rgba(59, 130, 246, 0.3),\n                    var(--df-glass-shadow);\n    }\n}\n\n/* Spinner rotation animation */\n@keyframes df-border-spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Loading overlay variant */\n.df-status-loading-overlay,\n.df-node-status-loading-overlay {\n    position: relative;\n}\n\n.df-node-status-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(2px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: inherit;\n    z-index: 10;\n}\n\n.df-node-status-spinner {\n    width: 24px;\n    height: 24px;\n    border: 3px solid rgba(59, 130, 246, 0.2);\n    border-top-color: var(--df-status-loading-color);\n    border-radius: 50%;\n    animation: df-border-spin 0.8s linear infinite;\n}\n\n/* Success state - green border with checkmark effect */\n.df-status-success,\n.df-node-status-success {\n    position: relative;\n    box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-success-color),\n                var(--df-glass-shadow);\n    animation: df-success-pulse 0.5s ease-out;\n}\n\n.df-status-success::after,\n.df-node-status-success::after {\n    content: '✓';\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    width: 20px;\n    height: 20px;\n    background: var(--df-status-success-color);\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n}\n\n@keyframes df-success-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5),\n                    var(--df-glass-shadow);\n    }\n    50% {\n        box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.2),\n                    var(--df-glass-shadow);\n    }\n    100% {\n        box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-success-color),\n                    var(--df-glass-shadow);\n    }\n}\n\n/* Error state - red border with X */\n.df-status-error,\n.df-node-status-error {\n    position: relative;\n    box-shadow: 0 0 0 var(--df-status-border-width) var(--df-status-error-color),\n                var(--df-glass-shadow);\n    animation: df-error-shake 0.4s ease-out;\n}\n\n.df-status-error::after,\n.df-node-status-error::after {\n    content: '✕';\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    width: 20px;\n    height: 20px;\n    background: var(--df-status-error-color);\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n}\n\n@keyframes df-error-shake {\n    0%, 100% {\n        transform: translateX(0);\n    }\n    20%, 60% {\n        transform: translateX(-4px);\n    }\n    40%, 80% {\n        transform: translateX(4px);\n    }\n}\n\n/* Dark mode adjustments */\n.dark .df-node-status-overlay,\n[data-mantine-color-scheme=\"dark\"] .df-node-status-overlay {\n    background: rgba(26, 27, 30, 0.8);\n}\n\n.dark .df-node-status-spinner,\n[data-mantine-color-scheme=\"dark\"] .df-node-status-spinner {\n    border-color: rgba(59, 130, 246, 0.3);\n    border-top-color: var(--df-status-loading-color);\n}\n\n/* Node search highlight */\n.df-node-search-highlight {\n    animation: df-highlight-pulse 1s ease-out;\n}\n\n@keyframes df-highlight-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);\n    }\n    50% {\n        box-shadow: 0 0 0 15px rgba(59, 130, 246, 0.3);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
